<template>
  <NuxtLayout name="default">
    <div class="exh_detail-container">
      <!-- :style="{
          backgroundImage: detail.backgroundImg
            ? `url('${detail.backgroundImg}')`
            : `url('${ContentBg}')`
        }" -->
      <div
        :style="{
          backgroundImage: detail.backgroundImg ? `url('${detail.backgroundImg}')` : ''
        }"
        class="top_bg">
        <img
          :src="ContentBg"
          fetchpriority="high"
          v-if="!detail.backgroundImg"
          class="back_image" />
        <div class="video-box">
          <video
            v-if="detail.backgroundVideo"
            id="video"
            :loop="false"
            :poster="detail.backgroundImg || ContentBg"
            :src="detail.backgroundVideo"
            autoplay
            class="bg-video"
            muted />
        </div>
        <div class="top_content">
          <div class="brand">
            <a
              :title="$t('common.site_title')"
              href="/"
              target="_blank">
              {{ $t('menu.home') }}
            </a>
            <ArrowRight />
            <a
              v-if="detail.regionType == 1"
              :title="$t('menu.international')"
              href="/exhibition/"
              target="_blank">
              {{ $t('menu.international') }}
            </a>
            <a
              v-else
              :title="$t('menu.domestic')"
              href="/exhibition-0-0-1-0-0-0-1/"
              target="_blank">
              {{ $t('menu.domestic') }}
            </a>
            <ArrowRight />
            <a
              v-if="detail.firstIndustryId > 0"
              :href="
                handleCheckUrl(
                  `/exhibition-${detail.firstIndustryId}-${detail.industry1}-${detail.regionType == 1 ? 0 : 1}-0-0-0-1/`,
                  'detail-1001'
                )
              "
              :title="industryFilter(detail.industry)"
              target="_blank">
              {{ setNavIndustry(detail.industry) }}
            </a>
            <a
              v-else
              :href="
                handleCheckUrl(
                  `/exhibition-${detail.industry1}-0-${detail.regionType == 1 ? 0 : 1}-0-0-0-1/`,
                  'detail-1002'
                )
              "
              :title="industryFilter(detail.industry)"
              target="_blank">
              {{ industryFilter(detail.industry) }}
            </a>
            <ArrowRight />
            <a
              :href="`/exhibition/${detail.exhibitionId}.html`"
              :title="detail.exhibitionName">
              {{ detail.exhibitionName }}
            </a>
          </div>
          <!-- dynamic:展会动态 0 普通展会 1 延期展会 2 变更展会 3 取消展会 -->
          <div class="exh_detail_basic_info">
            <div class="fair-cover">
              <img
                :alt="detail.exhibitionName"
                :src="logo(detail.pic)"
                loading="lazy" />
            </div>
            <div
              ref="exhDetailRightRef"
              class="exh_detail_right">
              <!-- https://dcdn-jufair-test.jufair.com/jufair/6dNbzXfEe3eBRSpCcyG7dDiQSWcmeFZj.jpg -->
              <!-- https://dcdn-jufair.jufair.com/service/exhibition-session.jpg -->
              <div style="min-height: 255px">
                <div style="position: relative">
                  <!-- <div
                      v-if="detail.numSessions"
                      class="sessions-tag row-flex ac jc">
                      <div
                        :style="{
                          'font-size': detail.numSessions.length > 1 ? '18px' : '35px'
                        }">
                        {{ $get(detail, 'numSessions', '') }}
                      </div>
                      <div
                        :style="{
                          top: detail.numSessions.length > 1 ? '10px' : '17px'
                        }"
                        class="unit">
                        st
                      </div>
                    </div> -->
                  <!-- 展会名称 dynamic 0 普通展会 1 延期展会 2 变更展会 3 取消展会-->
                  <template v-if="detail.dynamic < 2 || detail.dynamic == 5">
                    <h1>
                      <div class="detail_name">
                        <i
                          v-if="detail.tag"
                          :data-tag="detail.tag"
                          class="tag">
                          <template v-if="detail.tag == '热门'">
                            {{ $t('exhibition.hot') }}
                          </template>
                          <template v-if="detail.tag == '推荐'">
                            {{ $t('exhibition.recommended') }}
                          </template>
                          <template v-if="detail.tag == '精选'">
                            {{ $t('exhibition.winnow') }}
                          </template>
                        </i>
                        <i
                          v-if="$get(detail, 'numSessions', '')"
                          class="tag session">
                          第{{ $get(detail, 'numSessions', '') }}届
                        </i>
                        {{ detail.exhibitionName }}
                      </div>
                      <div
                        :style="{ width: detail.numSessions ? '85%' : '100%' }"
                        class="detail_en">
                        {{ detail.exhibitionEnglishName }}
                      </div>
                    </h1>
                  </template>
                  <template v-if="detail.dynamic == 3">
                    <div class="detail_name">
                      <i
                        v-if="detail.tag && detail.dynamic == 3"
                        :data-tag="detail.tag"
                        class="tag">
                        {{ detail.tag }}
                      </i>
                      <div>{{ detail.exhibitionName }}</div>
                    </div>
                    <div
                      :style="{ width: detail.numSessions ? '85%' : '100%' }"
                      class="detail_en">
                      {{ detail.exhibitionEnglishName }}
                    </div>
                  </template>
                  <div v-if="detail.dynamic == 2 || detail.dynamic == 4">
                    <div class="detail_name">
                      <i
                        class="el-icon-xin"
                        style="margin-right: 6px"></i>
                      <i
                        v-if="detail.tag"
                        :data-tag="detail.tag"
                        class="tag">
                        {{ detail.tag }}
                      </i>
                      <h1>{{ detail.exhibitionName }}</h1>
                    </div>
                    <h2
                      :style="{ width: detail.numSessions ? '85%' : '100%' }"
                      class="detail_en">
                      {{ detail.exhibitionEnglishName }}
                    </h2>
                  </div>
                </div>
                <!-- 展会时间 -->
                <div ref="dateRef">
                  <div
                    v-if="detail.dynamic == 0"
                    class="line line-width">
                    <i
                      class="el-icon-time2"
                      style="font-size: 20px"></i>
                    <span
                      v-if="isLogin"
                      class="line_value date">
                      {{ detail.lunchTime }}
                    </span>
                    <span
                      v-else
                      class="get-price date"
                      @click="shouldLogin">
                      {{ detail.lunchTime.substring(0, 7) }}...
                      <span style="font-size: 14px">{{ $t('exhibitionDetail.viewTime') }}</span>
                    </span>
                    <span
                      class="line_value"
                      style="font-size: 14px">
                      {{ $t('exhibitionDetail.openingHours') }}:
                      {{ detail.openTime || '09:00-18:00' }}
                    </span>
                  </div>
                  <div
                    v-if="
                      detail.dynamic == 1 ||
                      detail.dynamic == 2 ||
                      detail.dynamic == 3 ||
                      detail.dynamic == 4 ||
                      detail.dynamic == 5
                    "
                    class="line"
                    style="margin: 6px 0">
                    <!-- 标签: 展会延期,展会时间变更,展会取消 -->
                    <div
                      v-if="detail.dynamic == 1 || detail.dynamic == 4"
                      class="exh_delay">
                      时间变更
                    </div>
                    <!-- <div
                        v-if="detail.dynamic == 2"
                        class="exh_change exh_delay">展会时间变更</div> -->
                    <div
                      v-if="detail.dynamic == 3"
                      class="exh_close exh_delay">
                      展会取消
                    </div>
                    <div
                      v-if="detail.dynamic == 5"
                      class="exh_close exh_delay">
                      时间待定
                    </div>

                    <i class="el-icon-time2"></i>
                    <template v-if="isLogin">
                      <span
                        :class="detail.dynamic == 3 || detail.dynamic == 5 ? 'del' : ''"
                        class="line_value date"
                        style="max-width: 400px">
                        <template v-if="detail.dynamic == 0">{{ detail.lunchTime }}</template>
                        <template v-else>{{ detail.changeTime || detail.lunchTime }}</template>
                      </span>
                      <!-- <span
                        :class="detail.dynamic == 1 || detail.dynamic == 4 ? 'del' : ''"
                        class="line_value date"
                        style="max-width: 400px">
                        {{ detail.lunchTime }}
                      </span> -->
                    </template>
                    <span
                      v-else
                      :class="detail.dynamic == 3 || detail.dynamic == 5 ? 'del' : 'get-price'"
                      class="date"
                      @click="shouldLogin">
                      {{ detail.lunchTime.substring(0, 7) }}...
                      <span>{{ $t('exhibitionDetail.viewTime') }}</span>
                    </span>
                    <span
                      :class="detail.dynamic == 3 || detail.dynamic == 5 ? 'del' : ''"
                      class="line_value"
                      style="font-size: 14px">
                      {{ $t('exhibitionDetail.openingHours') }}:
                      {{ detail.openTime || '09:00-18:00' }}
                    </span>
                  </div>
                  <!-- <div
                      v-if="detail.dynamic == 2"
                      class="line weight new-date">
                      <span>新:</span>
                      <span
                        v-if="isLogin"
                        class="line_value date"
                        style="max-width: 400px">
                        {{ newDateFormat(detail) }}
                      </span>
                      <span
                        v-else
                        class="get-price date"
                        @click="shouldLogin">
                        {{ detail.lunchTime.substring(0, 7) }}...<span>{{ $t('exhibitionDetail.viewTime') }}</span>
                      </span>
                      <span
                        class="line_value"
                        style="font-size: 14px">
                        {{ $t('exhibitionDetail.openingHours') }}:
                        {{ detail.openTime || '09:00-18:00' }}
                      </span>
                    </div> -->
                </div>
                <div style="margin-top: 12px">
                  <!-- <p
                      v-if="detail.pavilionInfo"
                      class="line line-width">
                      <span class="line_label">{{ $t('exhibitionDetail.exhibitionAddress') }}:</span>
                      <span
                        :style="{
                          'font-size': detail.regionType == 1 ? '14px' : '16px'
                        }"
                        class="line_value"
                        style="max-width: 400px">
                        <template v-if="!lang || lang == 'cn'">
                          {{
                            detail.regionType == 1
                              ? $get(detail, 'pavilionInfo.pavilionEnglishAddress', '')
                              : $get(detail, 'pavilionInfo.pavilionAddress', '')
                          }}
                        </template>
                        <template v-else>
                          {{ $get(detail, 'pavilionInfo.pavilionEnglishAddress', '') }}
                        </template>
                      </span>
                      <span
                        class="address"
                        @click="getAddress">
                        {{ $t('exhibitionDetail.viewMap') }}
                      </span>
                    </p> -->
                  <p
                    v-if="detail.pavilionInfo"
                    class="line line-width">
                    <span
                      :style="{
                        'min-width': !lang || lang == 'cn' ? '70px' : 'auto'
                      }"
                      class="line_label">
                      {{ $t('exhibitionDetail.exhibitionHall') }}:
                    </span>
                    <span class="line_value">
                      <nuxt-link
                        :title="$get(detail, 'pavilionInfo.pavilionName', '')"
                        :to="`/pavilion/${$get(detail, 'pavilionInfo.id', '')}.html`"
                        target="_blank">
                        <template v-if="!lang || lang == 'cn'">
                          {{
                            detail.regionType == 1
                              ? $get(detail, 'pavilionInfo.pavilionEnglishName', '')
                              : $get(detail, 'pavilionInfo.pavilionName', '')
                          }}
                        </template>
                        <template v-else>
                          {{ $get(detail, 'pavilionInfo.pavilionEnglishName', '') }}
                        </template>
                      </nuxt-link>
                    </span>
                    <span
                      class="address"
                      @click="getAddress()">
                      {{ $t('exhibitionDetail.viewMap') }}
                    </span>
                  </p>
                  <p
                    v-if="detail.exhibitionAddress"
                    class="line line-width">
                    <span class="line_label">
                      {{ $t('exhibitionDetail.exhibitionHallNumber') }}:
                    </span>
                    <span class="line_value">
                      {{ $get(detail, 'exhibitionAddress', '') }}
                    </span>
                  </p>
                  <!-- <p class="line line-wrap">
                      <span
                        class="line-item"
                        style="margin-right: 20px">
                        <span class="line_label">{{ $t('exhibitionDetail.exhibitionArea') }}:</span>
                        <template v-if="!lang || lang == 'cn'">
                          {{ formatNumber(detail.scale) }}
                        </template>
                        <template v-else>{{ detail.scale }}</template>
                      </span>
                      <span
                        class="line-item"
                        style="margin-right: 20px">
                        <span class="line_label">{{ $t('exhibitionDetail.exhibitorsNumber') }}:</span>
                        <template v-if="!lang || lang == 'cn'">
                          {{ formatNumber(detail.exhibitors)
                          }}{{ $t('exhibitionDetail.exhibitorsNumberUnit') }}
                        </template>
                        <template v-else>{{ detail.exhibitors }}</template>
                      </span>
                      <span
                        class="line-item"
                        style="margin-right: 20px">
                        <span class="line_label">{{ $t('exhibitionDetail.audienceSize') }}:</span>
                        <template v-if="!lang || lang == 'cn'">
                          {{ formatNumber(detail.audience)
                          }}{{ $t('exhibitionDetail.audienceSizeUnit') }}
                        </template>
                        <template v-else>{{ detail.audience }}</template>
                      </span>
                    </p> -->
                  <!-- <p class="line line-wrap">
                      <span style="margin-right: 20px">
                        <span
                          class="line_label"
                          style="margin-right: 5px">
                          {{ $t('exhibitionDetail.cycle') }}:
                        </span>
                        {{ detail.periodsYear }}{{ $t('exhibition.year') }}{{ detail.periodsNum
                        }}{{ $t('exhibition.periods') }}
                      </span>
                    </p> -->

                  <!-- <div class="line">
                      <span
                        v-if="$get(detail, 'travelReminder', '')"
                        style="width: 320px; margin-right: 20px; display: flex; align-items: center">
                        <span class="line_label">出行提醒:</span>
                        <el-tooltip
                          :content="$get(detail, 'travelReminder', '')"
                          effect="light"
                          placement="top">
                          <span
                            class="ellipsis"
                            style="max-width: 400px; line-height: 22px">
                            {{ $get(detail, 'travelReminder', '') }}
                          </span>
                        </el-tooltip>
                      </span>
                    </div> -->
                  <!-- 展位价格 -->
                  <!-- <div
                      v-if="!lang || lang == 'cn'"
                      class="line">
                      <div class="boothPrice1">
                        <span class="line_label">{{ $t('exhibitionDetail.standardBooth') }}:</span>
                        <span v-if="isLogin">
                          {{ detail.boothPrice1 || '' }}
                          <a
                            v-if="!detail.boothPrice1"
                            :title="$t('exhibitionDetail.projectManagerQuotation')"
                            href="JavaScript:KS.openDirChatWin()"
                            rel="nofollow,noindex"
                            style="color: red">
                            {{ $t('exhibitionDetail.projectManagerQuotation') }}
                          </a>
                        </span>
                        <span
                          v-else
                          class="get-price"
                          @click="shouldLogin">
                          {{ $t('exhibitionDetail.viewPrice') }}
                        </span>
                      </div>

                      <div class="boothPrice2">
                        <span class="line_label">{{ $t('exhibitionDetail.bareSpaceBooth') }}:</span>
                        <span v-if="isLogin">
                          {{ detail.boothPrice2 || '' }}
                          <a
                            v-if="!detail.boothPrice2"
                            :title="$t('exhibitionDetail.projectManagerQuotation')"
                            href="JavaScript:KS.openDirChatWin()"
                            rel="nofollow,noindex"
                            style="color: red">
                            {{ $t('exhibitionDetail.projectManagerQuotation') }}
                          </a>
                        </span>
                        <span
                          v-else
                          class="get-price"
                          @click="shouldLogin">
                          {{ $t('exhibitionDetail.viewPrice') }}
                        </span>
                      </div>
                    </div> -->
                  <!-- <p class="line line-width">
                      <span class="line_label">{{ $t('exhibitionDetail.boothMap') }}:</span>
                      <span
                        class="get-price"
                        @click="handleApply()">
                        {{ $t('exhibitionDetail.getBoothMap') }}
                      </span>
                      <span
                        v-if="detail.hasSubsidy"
                        class="line-item line-button"
                        style="margin-right: 20px"
                        @click="handleSubsidy">
                        <span class="line_label">{{ $t('exhibitionDetail.subsidy') }}:</span>
                        {{ $t('exhibitionDetail.yes') }}
                      </span>
                    </p> -->
                  <!-- <p class="line line-width">
                      <span class="line_label">
                        {{ $t('exhibitionDetail.lastDay') }}
                      </span>
                    </p> -->
                  <!-- <p
                      v-if="tips.length > 0"
                      class="line"
                      style="max-width: 660px">
                      <span
                        class="line_label"
                        style="color: red">
                        {{ $t('exhibitionDetail.ticketDescription') }}:
                      </span>
                      <el-tooltip
                        v-for="item in tips"
                        :key="item.key"
                        :content="item.content">
                        <span class="ellipsis">
                          {{ item.content }}
                        </span>
                      </el-tooltip>
                    </p> -->
                  <div
                    v-if="detail.exhibitionNotes"
                    style="margin-top: 4px"
                    class="line line-width">
                    <!-- <span class="line_label">{{ $t('exhibitionDetail.exhibitionHighlights') }}:</span>
                      <span
                        v-for="item in detail.exhibitionNotesList"
                        :key="item"
                        class="line_point">
                        {{ item }}
                      </span> -->
                    <span
                      class="line_point"
                      v-for="item in detail.exhibitionNotesList"
                      :key="item">
                      {{ item }}
                    </span>
                  </div>
                </div>
                <div class="Exhibition-info">
                  <div class="Exhibition-li">
                    <img src="~/assets/images/cycle-icon.png" />
                    <div class="Exhibition-text">
                      <p class="cycle-text">{{ $t('exhibitionDetail.cycle') }}</p>
                      <p class="cycle-content">
                        {{ detail.periodsYear }}{{ $t('exhibition.year') }}{{ detail.periodsNum
                        }}{{ $t('exhibition.periods') }}
                      </p>
                    </div>
                  </div>
                  <div class="Exhibition-li">
                    <img src="~/assets/images/area-icon.png" />
                    <div class="Exhibition-text">
                      <p class="cycle-text">{{ $t('exhibitionDetail.exhibitionArea') }}</p>
                      <p class="cycle-content">
                        <template v-if="!lang || lang == 'cn'">
                          {{ formatNumber(detail.scale) }}
                        </template>
                        <template v-else>{{ detail.scale }}</template>
                      </p>
                    </div>
                  </div>
                  <div class="Exhibition-li">
                    <img src="~/assets/images/count-icon.png" />
                    <div class="Exhibition-text">
                      <p class="cycle-text">{{ $t('exhibitionDetail.exhibitorsNumber') }}</p>
                      <p
                        class="cycle-content"
                        v-if="detail.exhibitors">
                        <template v-if="!lang || lang == 'cn'">
                          {{ formatNumber(detail.exhibitors)
                          }}{{ $t('exhibitionDetail.exhibitorsNumberUnit') }}
                        </template>
                        <template v-else>{{ detail.exhibitors }}</template>
                      </p>
                    </div>
                  </div>
                  <div class="Exhibition-li">
                    <img src="~/assets/images/spectator-icon.png" />
                    <div class="Exhibition-text">
                      <p class="cycle-text">{{ $t('exhibitionDetail.audienceSize') }}</p>
                      <p class="cycle-content">
                        <template v-if="!lang || lang == 'cn'">
                          {{ formatNumber(detail.audience)
                          }}{{ $t('exhibitionDetail.audienceSizeUnit') }}
                        </template>
                        <template v-else>{{ detail.audience }}</template>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <!-- <fair-tag
                :exhibition-id="route.params.id as string"
                :exhibition-name="detail.exhibitionName"
                :industry-id="detail.industry1"
                :is-no-ticket="detail.isNoTicket"
                :third-url="detail.thirdUrl"
                style="margin-top: 8px"
                theme="black" /> -->
              <div style="margin-bottom: 8px; display: flex">
                <!--  -->
                <div
                  v-if="periodicalList.price || periodicalList.price === 0"
                  class="line periodical-price">
                  {{ $t('exhibitionDetail.exhibitorPeriodical') }}
                  <span style="font-size: 16px; margin-left: 5px">￥</span>
                  <span>{{ periodicalList.price }}</span>
                </div>
                <div
                  class="line ticket-price"
                  v-if="detail.ticket.isFreeTicket !== 1">
                  门票折扣价
                  <span class="price_value">
                    <template v-if="detail.minPrice || detail.minPrice === 0">
                      <span style="font-size: 16px">￥</span>
                      <span>{{ detail.minPrice }}</span>
                    </template>
                    <template v-else>
                      <span style="font-size: 20px">无票</span>
                    </template>
                  </span>
                  <span v-if="detail.marketPrice || detail.marketPrice === 0">
                    原价
                    <span class="oldPrice_value">￥{{ detail.marketPrice }}</span>
                  </span>
                </div>
              </div>
            </div>
            <div class="transpond">
              <img
                v-if="isFocus"
                @click="handleFollowFair"
                src="~/assets/images/collect-icon.png" />
              <img
                v-else
                @click="handleFollowFair"
                src="~/assets/images/uncollect-icon.png" />
              <img
                @click="handleShowMini"
                src="~/assets/images/weixin-icon.png" />
              <img
                @click="handlePoster"
                src="~/assets/images/transpond-icon.png" />
            </div>
            <div class="top__r column-flex jsb afe">
              <div>
                <div
                  v-if="(showMessage && messageList.length > 0 && !lang) || lang == 'cn'"
                  :style="`top: ${datePosition.top}px`"
                  class="order-message-box order-message-box__t"
                  @click="toExposer">
                  <el-carousel
                    autoplay
                    direction="vertical"
                    height="26px"
                    indicator-position="none"
                    loop>
                    <el-carousel-item
                      v-for="(item, index) in messageList"
                      :key="index">
                      <div class="order-message">
                        <img
                          :alt="item.userName"
                          :src="
                            item.avatar ? item.avatar + getXOssProcess({ w: 36, h: 36 }) : headimg
                          "
                          rel="nofollow,noindex" />
                        <div>
                          {{ `${item.contactName || item.userName}在${item.time}${item.typeDesc}` }}
                        </div>
                      </div>
                    </el-carousel-item>
                  </el-carousel>
                </div>
                <!-- 评分 -->
                <div class="cls sub-rate-box row-flex jsb">
                  <b class="">
                    <b class="rate">{{ rateValue }}</b>
                    <el-rate
                      v-model="rateValue"
                      disabled
                      text-color="#ff9900"></el-rate>
                  </b>
                  <div class="rate-info fl">
                    <ul class="info">
                      <li class="row-flex jsb ac">
                        <p class="tit">
                          <span>{{ $t('exhibitionDetail.scaleScore') }}</span>
                        </p>
                        <p class="progress">
                          <i
                            :style="{ width: getPercent(rateData.scaleScore) }"
                            class="tag flag_1"></i>
                        </p>
                      </li>
                      <li class="row-flex jsb ac">
                        <p class="tit">
                          <span>{{ $t('exhibitionDetail.specialityScore') }}</span>
                        </p>
                        <p class="progress">
                          <i
                            :style="{
                              width: getPercent(rateData.specialityScore)
                            }"
                            class="tag flag_2"></i>
                        </p>
                      </li>
                      <li class="row-flex jsb ac">
                        <p class="tit">
                          <span>{{ $t('exhibitionDetail.evaluateScore') }}</span>
                        </p>
                        <p class="progress">
                          <i
                            :style="{ width: getPercent(rateData.evaluateScore) }"
                            class="tag flag_3"></i>
                        </p>
                      </li>
                      <li class="row-flex jsb ac">
                        <p class="tit">
                          <span>{{ $t('exhibitionDetail.audienceScore') }}</span>
                        </p>
                        <p class="progress">
                          <i
                            :style="{ width: getPercent(rateData.audienceScore) }"
                            class="tag flag_4"></i>
                        </p>
                      </li>
                      <li class="row-flex jsb ac">
                        <p class="tit">
                          <span>{{ $t('exhibitionDetail.marketScore') }}</span>
                        </p>
                        <p class="progress">
                          <i
                            :style="{ width: getPercent(rateData.marketScore) }"
                            class="tag flag_5"></i>
                        </p>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div class="column-flex">
                <div
                  v-if="detail.dynamic === 0"
                  class="diff-days-wrap">
                  <div
                    v-if="+detail.countDays > 0"
                    class="diff-days-desc">
                    {{ $t('exhibitionDetail.distance') }}
                    <span class="days">{{ detail.countDays }}</span>
                    <span class="diff-unit">
                      {{ $t('exhibitionDetail.day') }}
                    </span>
                  </div>
                  <div
                    v-else-if="+detail.countDays === 0"
                    class="diff-days-desc">
                    {{ $t('exhibitionDetail.exhibitionInProgress') }}...
                  </div>
                  <div
                    v-else
                    class="diff-days-desc">
                    {{ $t('exhibitionDetail.nexttermTimeRenew') }}...
                  </div>
                  <!-- <div
                    v-if="+detail.countDays > 0"
                    class="diff-days-count">
                    <span class="days">{{ detail.countDays }}</span>
                    <span class="diff-unit">
                      {{ $t('exhibitionDetail.day') }}
                    </span>
                  </div> -->
                </div>
                <div
                  class="free-tag"
                  @click="handleToTicket">
                  {{
                    detail.ticket.isFreeTicket === 1
                      ? $t('exhibitionDetail.freeForALimitedTime')
                      : $t('exhibitionDetail.ticketReservation')
                  }}
                </div>
              </div>
            </div>
          </div>
          <!-- 多届展会 -->
          <div class="exh_detail_sessions">
            <div
              v-for="item in sessionsFair"
              :key="item.exhibitionId"
              class="item"
              @click="toExhibitionDel(item.exhibitionId)">
              <div class="logo">
                <NuxtImg
                  :src="getWebp(item.pic || item.logo)"
                  class="not-watermark"
                  loading="lazy" />
              </div>
              <div class="name">{{ item.exhibitionName }}</div>
              <div class="time">{{ item.lunchTime }}</div>
            </div>
          </div>
        </div>
      </div>
      <!-- 同期展会 -->
      <div
        v-if="$get(sameFair, 'records', []).length > 2"
        class="same-exh-area">
        <SectionTitle
          :title="$t('exhibitionDetail.samePeriodExhibition')"
          h2
          style="font-size: 18px; font-weight: bold; margin-bottom: 10px" />
        <client-only>
          <!-- :slides-per-view="2.3" -->
          <Swiper
            :autoplay="{ delay: 3000 }"
            :loop="false"
            :slides-per-view="3.2"
            :space-between="10"
            class="same-exh-list">
            <SwiperSlide
              v-for="item in $get(sameFair, 'records', [])"
              :key="item.exhibitionId"
              class="same-exh-item">
              <FairItem :item="item" />
            </SwiperSlide>
          </Swiper>
        </client-only>
      </div>
      <!-- 同期展会 -->
      <div
        v-if="$get(sameFair, 'records', []).length < 3 && $get(sameFair, 'records', []).length > 0"
        class="same-Replenishment">
        <section-title
          h2
          style="font-size: 18px; font-weight: bold; margin-bottom: 10px"
          :title="$t('exhibitionDetail.samePeriodExhibition')" />
        <section-title
          v-if="$get(industryFair, 'records', []).length > 0 && detail.regionType == 0"
          :class="$get(sameFair, 'records', []).length < 2 ? 'lessLeft' : 'moreLeft'"
          h2
          style="font-size: 18px; font-weight: bold; margin-bottom: 10px"
          :title="`${$t('common.china')}${detail.industry}${$t(
            'exhibitionDetail.relatedExhibition'
          )}`" />
        <section-title
          v-if="areaExhList.length > 0 && detail.regionType == 1"
          :class="$get(sameFair, 'records', []).length < 2 ? 'lessLeft' : 'moreLeft'"
          h2
          style="font-size: 18px; font-weight: bold; margin-bottom: 10px"
          :title="`${detail.pavilionInfo.areaName}${
            detail.industry
          } ${$t('exhibitionDetail.relatedExhibition')}`" />
        <client-only>
          <div class="replenishment-ul">
            <div
              class="replenishment-li"
              v-for="item in $get(sameFair, 'records', [])"
              :key="item.exhibitionId">
              <fair-item :item="item" />
            </div>

            <div
              class="template_box"
              :class="$get(sameFair, 'records', []).length < 2 ? 'moreHeight' : ''">
              <div
                style="display: flex"
                v-if="$get(industryFair, 'records', []).length > 0 && detail.regionType == 0">
                <div
                  v-for="item in $get(industryFair, 'records', [])"
                  :key="item.exhibitionId"
                  class="replenishment-li">
                  <fair-item :item="item" />
                </div>
              </div>
              <div
                style="display: flex"
                v-if="areaExhList.length > 0 && detail.regionType == 1">
                <div
                  v-for="item in areaExhList"
                  :key="item.exhibitionId"
                  class="replenishment-li">
                  <fair-item :item="item" />
                </div>
              </div>
            </div>
          </div>
        </client-only>
      </div>
      <div class="detail_content">
        <div
          v-if="showTitle"
          id="title"
          class="title_content">
          <div
            v-show="routeHash != '#view'"
            class="title_list">
            <a
              :href="`#${$t('exhibitionDetail.exhibitionIntroduction')}`"
              :style="{
                color:
                  current === $t('exhibitionDetail.exhibitionIntroduction') ? '#E50113' : '#666'
              }"
              @click="setCurrent(`${$t('exhibitionDetail.exhibitionIntroduction')}`)">
              {{ $t('exhibitionDetail.exhibitionIntroduction') }}
            </a>
            <a
              :href="`#${$t('exhibitionDetail.exhibitsRange')}`"
              :style="{
                color: current === $t('exhibitionDetail.exhibitsRange') ? '#E50113' : '#666'
              }"
              @click="setCurrent(`${$t('exhibitionDetail.exhibitsRange')}`)">
              {{ $t('exhibitionDetail.exhibitsRange') }}
            </a>
            <a
              :href="`#${$t('exhibitionDetail.exhibitionHall2')}`"
              :style="{
                color: current === $t('exhibitionDetail.exhibitionHall2') ? '#E50113' : '#666'
              }"
              @click="setCurrent(`${$t('exhibitionDetail.exhibitionHall2')}`)">
              {{ $t('exhibitionDetail.exhibitionHall2') }}
            </a>
            <a
              :href="`#${$t('userCommunity.userCommunity')}`"
              :style="{
                color: current === $t('userCommunity.userCommunity') ? '#E50113' : '#666'
              }"
              @click="setCurrent(`${$t('userCommunity.userCommunity')}`)">
              {{ $t('userCommunity.userCommunity') }}
            </a>
            <a
              :href="`#${$t('booth.boothPrice')}`"
              :style="{
                color: current === $t('booth.boothPrice') ? '#E50113' : '#666'
              }"
              @click="setCurrent(`${$t('booth.boothPrice')}`)">
              {{ $t('booth.boothPrice') }}
            </a>
          </div>
        </div>
        <div
          id="view"
          class="detail_left">
          <div class="attention_box">
            <!-- <div class="two">
              <i class="el-icon-weichat-white"></i>
              <span
                class="btn_font"
                @click="handleShowMini">
                {{ $t('exhibitionDetail.weChatShare') }}
              </span>
            </div> -->
            <!-- <div
              v-if="detail.regionType == 0"
              class="one"
              @click="getBusiness('hotel')"
            >
                    <span class="btn_font">
                      {{ $t('exhibitionDetail.hotelReservation') }}
                    </span>
            </div> -->
            <div
              v-if="detail.regionType == 1"
              class="one"
              @click="getBusiness('visa')">
              <span class="btn_font">
                {{ $t('exhibitionDetail.visaProcessing') }}
              </span>
            </div>

            <div
              v-show="showView"
              class="four"
              @click="handleContent">
              <span class="btn_font">
                {{ $t('exhibitionDetail.exhibitionIntroduction') }}
              </span>
            </div>
            <div
              :class="{ active: routeHash == '#view' ? true : false }"
              class="four"
              @click="handleView">
              <span class="btn_font">
                {{ $t('exhibitionDetail.exhibitionPicture') }}
              </span>
            </div>
            <div
              v-if="!isFocus"
              @click="handleFollowFair"
              class="one follow">
              <span class="btn_font">
                {{ $t('personal.right.follow_exhibition') }}
              </span>
            </div>
            <div
              v-else
              class="four"
              @click="handleFollowFair"
              :class="{ active: routeHash == '#view' ? true : false }">
              <span class="btn_font">已关注</span>
            </div>
            <div class="hot-area">
              <img
                :alt="$t('exhibitionDetail.view')"
                rel="nofollow,noindex"
                src="~/assets/icon/fire.png" />
              <div class="hot_num">
                {{ numFormat(detail.hot) }}{{ $t('exhibitionDetail.view') }}
              </div>
            </div>
          </div>
          <!-- 展会视图 -->
          <div v-show="showView">
            <ResourceView
              :detail="detail"
              :list="resourceList"></ResourceView>
          </div>

          <div v-show="routeHash != '#view'">
            <div
              v-if="photos.length || detail.video"
              class="image_section content-section">
              <div class="medium_list">
                <client-only>
                  <Swiper
                    v-if="photos.length >= 3"
                    :autoplay="{
                      delay: 3000
                    }"
                    :loop="false"
                    :slides-per-view="3.2"
                    :space-between="10">
                    <SwiperSlide
                      v-if="$get(detail, 'video.resourceUrl', null)"
                      class="video-area">
                      <div
                        class="prism-player"
                        @click="openVideo()">
                        <img
                          :src="logo(detail.pic)"
                          :alt="detail.exhibitionName"
                          rel="nofollow,noindex" />
                        <i class="iconfont el-icon-bofang"></i>
                      </div>
                    </SwiperSlide>
                    <SwiperSlide
                      v-for="(item, index) in photos"
                      :key="item"
                      class="medium_item">
                      <el-image
                        v-if="isLogin"
                        :src="item"
                        :alt="detail.exhibitionName"
                        :initial-index="index"
                        :preview-teleported="true"
                        :previewSrcList="photos"
                        rel="nofollow,noindex" />
                      <img
                        v-else
                        :src="item"
                        :alt="detail.exhibitionName"
                        rel="nofollow,noindex"
                        @click="handlePreview" />
                    </SwiperSlide>
                  </Swiper>
                </client-only>
                <template v-if="photos.length < 3">
                  <div
                    v-if="$get(detail, 'video.resourceUrl', null)"
                    class="video-area">
                    <div
                      class="prism-player"
                      @click="openVideo()">
                      <img
                        :src="logo(detail.pic)"
                        :alt="detail.exhibitionName"
                        rel="nofollow,noindex"
                        loading="lazy" />
                      <i class="iconfont el-icon-bofang"></i>
                    </div>
                  </div>
                  <div
                    v-for="item in photos"
                    :key="item"
                    class="medium_item">
                    <img
                      v-if="isLogin"
                      :src="item"
                      :alt="detail.exhibitionName"
                      rel="nofollow,noindex"
                      preview="0" />
                    <img
                      v-else
                      :src="item"
                      :alt="detail.exhibitionName"
                      rel="nofollow,noindex"
                      @click="handlePreview" />
                  </div>
                </template>
              </div>
            </div>
          </div>
          <div
            v-show="!showView"
            class="exh_detail_tabs_content">
            <el-tabs
              v-model="activeName"
              @tab-click="handleClick">
              <el-tab-pane
                :label="$t('exhibitionDetail.exhibitionIntroduction')"
                name="first">
                <div class="content-section">
                  <div class="fair-data">
                    <div
                      v-if="detail.industry"
                      class="content-line">
                      <span class="line_label">{{ $t('exhibitionDetail.industry') }}:</span>
                      <span
                        v-for="(industry, idx) in industryList"
                        :key="industry"
                        class="line_value line_industry">
                        <span v-if="idx === 0">
                          <nuxt-link
                            v-if="detail.firstIndustryId === 0"
                            :to="`/exhibition-${detail.industry1}-0-${detail.regionType == 0 ? 1 : 0}-0-0-0-1/`"
                            target="_blank">
                            {{ industry }}
                          </nuxt-link>
                          <nuxt-link
                            v-else
                            :to="`/exhibition-${detail.firstIndustryId}-${detail.industry1}-${detail.regionType == 0 ? 1 : 0}-0-0-0-1/`"
                            target="_blank">
                            {{ industry }}
                          </nuxt-link>
                        </span>
                        <span v-else>{{ industry }}</span>
                      </span>
                    </div>
                    <div class="content-line">
                      <div class="line_label">{{ $t('exhibitionDetail.organizer') }}:</div>
                      <div class="line_value">
                        {{ detail.organizer }}
                      </div>
                    </div>
                  </div>
                  <a
                    :data-name="$t('exhibitionDetail.exhibitionIntroduction')"
                    :name="$t('exhibitionDetail.exhibitionIntroduction')"
                    class="point">
                    <section-title
                      :title="`${detail.exhibitionName}${$t(
                        'exhibitionDetail.exhibitionIntroduction'
                      )}`"
                      h2
                      style="font-size: 18px" />
                  </a>
                  <div
                    class="introduction_exh"
                    v-html="xss(getContent(detail.introduction))" />
                </div>

                <div class="periodical-box">
                  <section-title
                    h2
                    style="font-size: 18px; font-weight: 500; margin-bottom: 10px"
                    :title="$t('exhibitionDetail.exhibitorPeriodical')" />
                  <div class="current-exhibitor-box">
                    <img
                      class=""
                      src="~/assets/images/exhibitor.png" />
                    <div class="exhibitor-info">
                      <p class="exhibitor-name ellipsis">
                        {{ periodicalList.year ? periodicalList.year + '年' : ''
                        }}{{ detail.exhibitionName }}{{ periodicalList.name }}
                      </p>
                      <p
                        class="exhibitor-count"
                        v-if="periodicalList.exhibitorCount">
                        {{ $t('exhibitionDetail.exhibitorNumber') }}：{{
                          periodicalList.exhibitorCount || 0
                        }}
                      </p>
                    </div>
                    <p class="exhibitor-price">￥{{ periodicalList.price || '0.00' }}</p>
                    <div
                      class="exhibitor-buy"
                      @click="readPeriodical">
                      立即购买
                    </div>
                  </div>
                  <div
                    class="company-ul"
                    v-if="periodicalList.jump">
                    <div
                      @click="toCompanyDetail(item.id)"
                      class="company-li"
                      v-for="item in exhibitorData.records || []"
                      :key="item">
                      <div class="company-base">
                        <div class="company-icon">{{ getCompanyName(item.exhibitorName) }}</div>
                        <div class="company-info">
                          <p class="company-name ellipsis">
                            <span>{{ item.exhibitorName || '' }}</span>
                            <span v-if="item.exhibitorName != item.companyEnglishName">
                              {{ item.companyEnglishName || '' }}
                            </span>
                          </p>
                          <div class="tag-list">
                            <span
                              class="tag-box tag-1"
                              v-if="item.contactsTel">
                              电话
                            </span>
                            <span
                              class="tag-box tag-2"
                              v-if="item.companyEmail">
                              邮箱
                            </span>
                            <span
                              class="tag-box tag-3"
                              v-if="item.companyUrl">
                              网址
                            </span>
                            <span
                              class="tag-box tag-4"
                              v-if="item.productName">
                              {{ item.productName ? item.productName.slice(0, 4) + '...' : '' }}
                            </span>
                          </div>
                        </div>
                        <div class="booth-number">
                          <span>展位号：</span>
                          <span class="number-text">{{ item.booth || '-' }}</span>
                        </div>
                      </div>
                      <div class="company-detail">
                        <p
                          style="width: 170px"
                          class="ellipsis"
                          v-if="$get(item.companyGovRegister, 'legalPerson', '')">
                          法定代表人：
                          <span>{{ $get(item.companyGovRegister, 'legalPerson', '') }}</span>
                        </p>
                        <p
                          style="width: 170px"
                          class="ellipsis"
                          v-if="$get(item.companyGovRegister, 'capitalAmount', '')">
                          注册资本：
                          <span>
                            {{ $get(item.companyGovRegister, 'capitalAmount', '')
                            }}{{ $get(item.companyGovRegister, 'capitalUnit', '') }}
                          </span>
                        </p>
                        <p
                          style="width: 160px"
                          class="ellipsis"
                          v-if="$get(item.companyGovRegister, 'establishmentTime', '')">
                          成立时间：
                          <span>
                            {{ $get(item.companyGovRegister, 'establishmentTime', '') }}
                          </span>
                        </p>
                        <p
                          class="ellipsis"
                          v-if="$get(item, 'exhibitorCountry', '')"
                          style="width: 180px; margin-right: 0">
                          国际/地区：
                          <span>
                            {{ $get(item, 'exhibitorCountry', '') }}
                          </span>
                        </p>
                      </div>
                    </div>
                    <div
                      @click="readPeriodical"
                      class="charge-box"
                      v-if="!hasOrder && exhibitorData.records.length">
                      <div class="line"></div>
                      <div class="lock-text">
                        <img src="~/assets/images/lock-icon.png" />
                        <span>购买后解锁{{ periodicalList.exhibitorCount }}家展商名录</span>
                      </div>
                      <div class="line"></div>
                    </div>
                    <div
                      class="charge-more"
                      v-if="hasOrder && exhibitorData.records.length">
                      <div class="line"></div>
                      <nuxt-link
                        class="lock-text"
                        :to="`/exhibitors/${
                          $route.params.id
                        }.html?periodicalId=${periodicalList.id}&name=${
                          periodicalList.year + periodicalList.name
                        }`"
                        target="_blank">
                        查看更多
                      </nuxt-link>
                      <div class="line"></div>
                    </div>
                  </div>
                </div>
                <div class="content-section">
                  <a
                    :data-name="$t('exhibitionDetail.exhibitsRange')"
                    :name="$t('exhibitionDetail.exhibitsRange')"
                    class="point">
                    <section-title
                      :title="`${detail.exhibitionName}${$t('exhibitionDetail.exhibitsRange')}`"
                      h2
                      style="font-size: 18px" />
                  </a>
                  <div
                    class="exh_range"
                    v-html="xss(getContent(detail.scope))" />
                </div>

                <!-- 展会顾问 -->
                <div
                  v-if="$get(industryFair, 'records', []).length > 0 && detail.regionType == 0"
                  class="industry-exh"
                  style="width: 854px">
                  <section-title
                    :title="`${$t('common.china')}${detail.industry}${$t(
                      'exhibitionDetail.relatedExhibition'
                    )}`"
                    style="font-size: 18px; font-weight: bold; margin-bottom: 10px" />
                  <client-only>
                    <Swiper
                      :options="{ ...sameSwiperOption, slidesPerView: 2.3 }"
                      class="same-exh-list">
                      <SwiperSlide
                        v-for="item in $get(industryFair, 'records', [])"
                        :key="item.exhibitionId"
                        class="same-exh-item">
                        <fair-item :item="item" />
                      </SwiperSlide>
                    </Swiper>
                  </client-only>
                </div>
                <!-- 相关展会 -->
                <div
                  v-if="areaExhList.length > 0 && detail.regionType == 1"
                  class="same-exh-area"
                  style="width: 854px">
                  <section-title
                    :title="`${detail.pavilionInfo.areaName}${
                      detail.industry
                    } ${$t('exhibitionDetail.relatedExhibition')}`"
                    style="font-size: 18px; font-weight: bold; margin-bottom: 10px" />
                  <client-only>
                    <Swiper
                      :autoplay="{
                        delay: 3000
                      }"
                      :loop="false"
                      :slides-per-view="2.3"
                      :space-between="10"
                      class="same-exh-list">
                      <SwiperSlide
                        v-for="item in areaExhList"
                        :key="item.exhibitionId"
                        class="same-exh-item">
                        <fair-item :item="item" />
                      </SwiperSlide>
                    </Swiper>
                  </client-only>
                </div>

                <div class="download_box">
                  <!-- :style="{
                      backgroundImage: `url(${item.url})`
                    }" -->
                  <div
                    v-for="item in downloadList"
                    :key="item.text"
                    class="download_box_tag">
                    <img
                      :src="item.url"
                      loading="lazy"
                      class="bg_image" />
                    <div class="download-content">
                      <p
                        class="download-name"
                        :class="item.text == '展商名录/电子会刊' ? 'directory-name' : ''">
                        {{ item.text }}
                      </p>
                      <p
                        @click="apply(item.text)"
                        class="download-pay"
                        :class="item.text == '展商名录/电子会刊' ? 'directory-pay' : ''">
                        立即获取
                        <i class="icon_base el-icon-arrow-right"></i>
                      </p>
                    </div>
                  </div>
                </div>

                <div class="content-section service-area">
                  <section-title
                    :title="`${detail.exhibitionName}${$t('customerService.boothConsultation')}`"
                    h2
                    style="font-size: 18px" />
                  <div
                    v-for="item in boothServiceList"
                    :key="item.id"
                    class="service-item">
                    <div class="service-left">
                      <div class="service-avatar">
                        <NuxtImg
                          :src="item.avatar"
                          :alt="item.nickName"
                          loading="lazy"
                          rel="nofollow,noindex" />
                      </div>
                      <div class="service-info">
                        <div class="service-name">
                          <template v-if="!lang || lang == 'cn'">
                            {{ item.nickName }}
                          </template>
                          <template v-else>{{ item.englishNickName }}</template>
                          <span
                            v-if="!lang || lang == 'cn'"
                            class="service-label">
                            {{ item.postTitleName }}
                          </span>
                        </div>
                        <div
                          v-if="!lang || lang == 'cn'"
                          class="service-desc">
                          {{ item.skillDesc }}
                        </div>
                      </div>
                    </div>
                    <div class="service-other">
                      <div class="service-tel">
                        <div
                          v-if="item.companyPhone"
                          class="service-tel2">
                          {{ $t('customerService.telephone') }}
                          {{ item.companyPhone }}
                        </div>
                        <client-only>
                          <div
                            v-if="(item.companyMobile && !lang) || lang == 'cn'"
                            class="service-tel2">
                            {{ $t('customerService.mobilePhone') }}
                            {{ item.companyMobile }}
                          </div>
                        </client-only>
                      </div>
                      <div class="service-qrcode">
                        <span>{{ $t('customerService.wechat') }}</span>
                        <img
                          :src="Wei2"
                          alt="wechat"
                          loading="lazy"
                          class="wechat-icon"
                          rel="nofollow,noindex" />
                        <div class="qrcode-area">
                          <img
                            :alt="$t('customerService.wechat')"
                            :src="
                              item.companyWxQr
                                ? item.companyWxQr + getXOssWebpSize({ w: 300, h: 400 })
                                : ''
                            "
                            loading="lazy"
                            class="qrcode"
                            rel="nofollow,noindex" />
                        </div>
                      </div>
                      <div
                        class="service-btn"
                        @click="handleOnlineService">
                        <a
                          href="JavaScript:KS.openDirChatWin()"
                          rel="nofollow,noindex">
                          <i class="el-icon-evaluate" />
                          {{ $t('customerService.onlineContact') }}
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="content-section service-area">
                  <section-title
                    :title="`${detail.exhibitionName}${$t(
                      'customerService.exhibitionTicketConsultation'
                    )}`"
                    h2
                    style="font-size: 18px" />
                  <div
                    v-for="item in ticketServiceList"
                    :key="item.id"
                    class="service-item">
                    <div class="service-left">
                      <div class="service-avatar">
                        <img
                          :src="item.avatar"
                          :alt="item.nickName"
                          loading="lazy"
                          rel="nofollow,noindex" />
                      </div>
                      <div class="service-info">
                        <div class="service-name">
                          <template v-if="!lang || lang == 'cn'">
                            {{ item.nickName }}
                          </template>
                          <template v-else>{{ item.englishNickName }}</template>
                          <span
                            v-if="!lang || lang == 'cn'"
                            class="service-label">
                            {{ item.postTitleName }}
                          </span>
                        </div>
                        <div
                          v-if="!lang || lang == 'cn'"
                          class="service-desc">
                          {{ item.skillDesc }}
                        </div>
                      </div>
                    </div>
                    <div class="service-other">
                      <div class="service-tel">
                        <div
                          v-if="item.companyPhone"
                          class="service-tel2">
                          {{ $t('customerService.telephone') }}
                          {{ item.companyPhone }}
                        </div>
                        <client-only v-if="detail.regionType == 1">
                          <div
                            v-if="(item.companyMobile && !lang) || lang == 'cn'"
                            class="service-tel2">
                            {{ $t('customerService.mobilePhone') }}
                            {{ item.companyMobile }}
                          </div>
                        </client-only>
                        <client-only v-else>
                          <div
                            v-if="item.companyMobile"
                            class="service-tel2">
                            {{ $t('footer.work_time2') }} 09:00-18:00
                          </div>
                        </client-only>
                      </div>
                      <div class="service-qrcode">
                        <span>{{ $t('customerService.wechat') }}</span>
                        <img
                          :src="Wei2"
                          alt="wechat"
                          class="wechat-icon"
                          rel="nofollow,noindex" />
                        <div class="qrcode-area">
                          <img
                            :src="
                              item.companyWxQr
                                ? item.companyWxQr + getXOssWebpSize({ w: 300, h: 400 })
                                : ''
                            "
                            loading="lazy"
                            class="qrcode"
                            rel="nofollow,noindex" />
                        </div>
                      </div>
                      <div
                        class="service-btn"
                        @click="handleOnlineService">
                        <a
                          href="JavaScript:KS.openDirChatWin()"
                          rel="nofollow,noindex">
                          <i class="el-icon-evaluate" />
                          {{ $t('customerService.onlineContact') }}
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-if="banner.length > 0">
                  <div
                    v-for="item in banner.slice(0, 1)"
                    :key="item.url"
                    class="banner-tag">
                    <a
                      :href="item.link"
                      target="_blank">
                      <img
                        :src="item.url"
                        :alt="detail.exhibitionName"
                        class="banner-img"
                        rel="nofollow,noindex" />
                    </a>
                  </div>
                </div>
                <div class="content-section">
                  <a
                    :data-name="`${$t('exhibitionDetail.exhibitionHall2')}`"
                    :name="`${$t('exhibitionDetail.exhibitionHall2')}`"
                    class="point">
                    <section-title
                      :title="`${detail.exhibitionName}${$t('exhibitionDetail.exhibitionHall2')}`"
                      h2
                      style="font-size: 18px" />
                  </a>
                  <div class="pavilion">
                    <div
                      v-if="detail.regionType == 0"
                      class="pavilion_name">
                      <span
                        v-if="$get(detail, 'pavilionInfo.pavilionEnglishName', '')"
                        style="margin-right: 20px">
                        <template v-if="!lang || lang == 'cn'">
                          {{ $get(detail, 'pavilionInfo.pavilionEnglishName', '') }}
                        </template>
                        <template v-else>
                          {{ $get(detail, 'pavilionInfo.pavilionEnglishName', '') }}
                        </template>
                      </span>

                      <span
                        class="info-item_button"
                        @click="getAddress()">
                        {{ $t('exhibitionDetail.viewMap') }}
                      </span>
                    </div>
                    <div
                      v-else-if="detail.regionType == 1"
                      class="pavilion_name">
                      <span
                        v-if="
                          $get(
                            detail,
                            'pavilionInfo.pavilionEnglishName',
                            $get(detail, 'pavilionInfo.pavilionName', '')
                          )
                        "
                        style="margin-right: 20px">
                        {{
                          $get(
                            detail,
                            'pavilionInfo.pavilionEnglishName',
                            $get(detail, 'pavilionInfo.pavilionName', '')
                          )
                        }}
                      </span>
                      <span
                        class="info-item_button"
                        @click="getAddress()">
                        {{ $t('exhibitionDetail.viewMap') }}
                      </span>
                    </div>
                    <div class="pavilion_address">
                      {{ $t('exhibitionDetail.exhibitionHall') }}:
                      <template v-if="!lang || lang == 'cn'">
                        {{
                          $get(detail, 'pavilionInfo.pavilionAddress', '') ||
                          $get(detail, 'pavilionInfo.pavilionEnglishAddress', '')
                        }}
                      </template>
                      <template v-else>
                        {{ $get(detail, 'pavilionInfo.pavilionEnglishAddress', '') }}
                      </template>
                    </div>
                    <div
                      v-if="false"
                      class="pavilion_phone">
                      {{ $t('fixed_sidebar.phone') }}:
                      {{ $get(detail, 'pavilionInfo.pavilionPhoneNum', '') }}
                    </div>
                    <div class="pavilion-area">
                      <el-carousel
                        v-if="detail.pavilionInfo.picture"
                        autoplay
                        height="297px"
                        style="margin-right: 15px">
                        <el-carousel-item
                          v-for="(item, index) in pavilionPicture"
                          :key="item">
                          <div
                            :key="item"
                            class="img_con">
                            <el-image
                              v-if="isLogin"
                              :src="item"
                              :alt="detail.pavilionInfo.pavilionName"
                              :lazy="true"
                              :initial-index="index"
                              :preview-src-list="pavilionPicture"
                              :preview-teleported="true"
                              rel="nofollow,noindex" />
                            <NuxtImg
                              v-else
                              :src="item"
                              :alt="detail.pavilionInfo.pavilionName"
                              loading="lazy"
                              rel="nofollow,noindex"
                              @click="shouldLogin" />
                          </div>
                        </el-carousel-item>
                      </el-carousel>
                      <ju-map
                        :attribution="attribution"
                        :center="center"
                        :detail="detail.pavilionInfo" />
                    </div>
                  </div>
                </div>

                <div
                  v-if="follow.total > 0"
                  class="content-section">
                  <a
                    ref="exposer"
                    :data-name="`${$t('userCommunity.userCommunity')}`"
                    :name="`${$t('userCommunity.userCommunity')}`"
                    class="point" />
                  <section-title
                    :title="`${detail.exhibitionName}${$t('userCommunity.userCommunity')}`"
                    h2
                    style="font-size: 18px; margin-bottom: 17px" />
                  <FairUser :data="follow.data" />
                  <div
                    v-if="follow.total > 12"
                    class="pagination-wrapper">
                    <span
                      style="cursor: pointer"
                      @click="toCommunity">
                      {{ $t('common.more') }}
                    </span>
                  </div>
                </div>
                <div class="content-section">
                  <a
                    :data-name="$t('booth.boothPrice')"
                    :name="$t('booth.boothPrice')"
                    class="point" />
                  <section-title
                    :title="`${detail.exhibitionName}${$t('booth.boothPrice')}`"
                    h2
                    style="font-size: 18px; margin-bottom: 17px" />
                  <Booth
                    :booth="detail"
                    :exhibition-id="detail.exhibitionId" />
                  <section-title
                    :title="`${detail.exhibitionName}${$t('exhibitionProcess.name')}`"
                    h2
                    style="font-size: 18px; margin-bottom: 17px; margin-top: 13px" />
                  <div class="procedure">
                    <p>{{ $t('exhibitionProcess.item1') }}</p>
                    <p>{{ $t('exhibitionProcess.item2') }}</p>
                    <p>{{ $t('exhibitionProcess.item3') }}</p>
                    <p>{{ $t('exhibitionProcess.item4') }}</p>
                    <p>{{ $t('exhibitionProcess.item5') }}</p>
                    <p>{{ $t('exhibitionProcess.item6') }}</p>
                  </div>
                </div>
              </el-tab-pane>
              <!-- TODO 一期不做 -->
              <el-tab-pane
                v-if="false"
                :label="$t('exhibitionDetail.tourItinerary')"
                name="third">
                <!-- 展团行程, 国际展会显示 -->
                <div class="content-section">
                  <Route :detail="detail" />
                </div>
              </el-tab-pane>
            </el-tabs>
          </div>
        </div>
        <div class="detail_right">
          <!-- class="aside-sticky" :style="{ position: routeHash != 'view' ? 'sticky' : 'unset' }" -->
          <div class="aside-sticky">
            <div
              v-show="messageList.length > 0"
              class="order-message-box"
              @click="toExposer">
              <div class="exposer-line">
                <div class="line-left">
                  <span class="num">{{ follow.total }}</span>
                  {{ $t('exhibitionDetail.attend') }}
                </div>
                <div class="line-right">
                  <span class="tag-item tag-item__b">
                    {{ $t('userCommunity.userCommunity') }}
                  </span>
                  <i class="el-icon-arrow-right" />
                </div>
              </div>
              <div
                v-if="follow.data"
                class="avatar_div">
                <div class="avatar-list">
                  <div
                    v-for="item in follow.data.slice(0, 6)"
                    :key="item.companyName"
                    class="avatar_box">
                    <!-- <img
                      :src="item.avatar ? item.avatar + getXOssProcess({ w: 30, h: 30 }) : headimg"
                      alt="头像"
                      class="set-img"
                      rel="nofollow,noindex"
                      title="头像" /> -->
                    <img
                      :src="item.avatar ? item.avatar + getXOssWebpSize({ w: 30, h: 30 }) : headimg"
                      alt="头像"
                      class="set-img"
                      rel="nofollow,noindex"
                      title="头像" />
                  </div>
                </div>
                <div class="avatar_name">
                  {{ follow.data.length ? follow.data[0].companyName : '' }}
                </div>
              </div>
            </div>
            <div
              v-if="!blackList.includes(Number(detail.exhibitionId))"
              class="read_buy_content2">
              <div class="left">
                <div
                  class="application_btn"
                  @click="handleApply()">
                  <div>{{ $t('exhibitionDetail.boothApply') }}</div>
                  <img src="~/assets/images/button_back.png" />
                </div>
              </div>
              <div class="right column-flex">
                <div
                  class="btn"
                  @click="handleToTicket">
                  <div
                    v-if="detail.ticket.isFreeTicket === 1"
                    class="bg">
                    {{ $t('exhibitionDetail.freeForALimitedTime') }}
                  </div>
                  <div
                    v-else
                    class="bg">
                    {{ $t('exhibitionDetail.ticketReservation') }}
                  </div>
                </div>
                <div
                  class="btn"
                  @click="readPeriodical">
                  <div class="bg">
                    {{ $t('exhibitionDetail.exhibitorPeriodical') }}
                  </div>
                </div>
              </div>
            </div>
            <div class="tips-area">
              <div class="tips-title">
                <i class="el-icon-careful" />
                {{ $t('exhibitionDetail.warmReminder') }}
              </div>
              <div class="tips-content">
                {{ $t('exhibitionDetail.warmReminderContent') }}
              </div>
              <div class="notice">
                <p class="notice_tit">
                  <i class="el-icon-notice"></i>
                  <span>{{ $t('exhibitionDetail.notificationReminder') }}</span>
                </p>
                <div class="notice_content">
                  <div class="notice_left">
                    <div class="add_my">
                      {{ $t('exhibitionDetail.addReminder') }}
                    </div>
                    <!-- <div class="get_my">
                      <nuxt-link
                        :title="$t('exhibitionDetail.exhibitionReminder')"
                        rel="nofollow,noindex"
                        target="_blank"
                        to="/manager/fair-remind/">
                        {{ $t('exhibitionDetail.viewReminder') }}
                        <i class="el-icon-arrow-right" />
                      </nuxt-link>
                    </div> -->
                  </div>
                  <div class="notice_right">
                    <span
                      v-if="!remind"
                      class="onbut but"
                      @click="handleRemind">
                      {{ $t('exhibitionDetail.openNotification') }}
                    </span>
                    <span
                      v-if="remind"
                      class="offbut but"
                      @click="handleRemind">
                      {{ $t('exhibitionDetail.closeNotification') }}
                    </span>
                  </div>
                </div>
              </div>
              <div class="wechat-area">
                <div class="tip_tit">
                  <i class="el-icon-careful"></i>
                  <span style="font-weight: 800">
                    {{ $t('exhibitionDetail.changeNotice') }}
                  </span>
                </div>
                <media-box style="margin-top: 16px" />
              </div>
            </div>
            <div class="server-area">
              <div class="notice_tit">
                <span>{{ $t('customerService.boothSale') }}</span>
              </div>
              <div
                v-for="item in boothServiceList"
                :key="item.id"
                class="server">
                <div class="server-left">
                  <div class="server-icon">
                    <img
                      :src="item.avatar"
                      :alt="item.nickName"
                      rel="nofollow,noindex" />
                  </div>
                  <div class="server-info">
                    <div class="server-name">
                      <template v-if="!lang || lang == 'cn'">
                        {{ item.nickName }}
                      </template>
                      <template v-else>{{ item.englishNickName }}</template>
                    </div>
                    <div
                      v-if="!lang || lang == 'cn'"
                      class="server-pai">
                      {{ item.postTitleName }}
                    </div>
                  </div>
                </div>
                <div
                  class="server-btn"
                  @click="handleOnlineService">
                  <a
                    href="JavaScript:KS.openDirChatWin()"
                    rel="nofollow,noindex">
                    <i class="el-icon-evaluate" />
                    {{ $t('customerService.onlineContact') }}
                  </a>
                </div>
              </div>
              <div
                v-for="(item, index) in boothServiceList"
                :key="`${index}_${item.id}`">
                <div class="service-other">
                  <div class="service-tel">
                    <div
                      v-if="item.companyPhone"
                      class="service-tel2">
                      {{ $t('customerService.telephone') }}
                      {{ item.companyPhone }}
                    </div>
                    <client-only>
                      <div
                        v-if="(item.companyMobile && !lang) || lang == 'cn'"
                        class="service-tel2">
                        {{ $t('customerService.mobilePhone') }}
                        {{ item.companyMobile }}
                      </div>
                    </client-only>
                  </div>
                  <div
                    class="service-qrcode"
                    style="margin: 8px 0 8px 0">
                    <span>{{ $t('customerService.wechat') }}</span>
                    <img
                      :src="Wei2"
                      alt="wechat"
                      class="wechat-icon"
                      rel="nofollow,noindex" />
                    <div class="qrcode-area">
                      <img
                        :src="
                          item.companyWxQr
                            ? item.companyWxQr + getXOssWebpSize({ w: 300, h: 400 })
                            : ''
                        "
                        loading="lazy"
                        alt="wechat"
                        class="qrcode"
                        rel="nofollow,noindex" />
                    </div>
                  </div>
                </div>
              </div>

              <div style="font-size: 14px">
                <p>
                  {{ $t('customerService.workTime') }}: {{ $t('footer.work_time2') }} 09:00-18:00
                </p>
              </div>
            </div>
            <!--相关热点推荐-->
            <div
              v-if="tag.length > 0"
              class="tag-area">
              <div class="notice_tit">
                <span>
                  {{ $t('exhibitionDetail.relatedHotspotRecommendation') }}
                </span>
              </div>
              <div class="tag-list">
                <nuxt-link
                  v-for="item in tag"
                  :key="item.id"
                  :to="`/special/${item.id}.html`"
                  target="_blank">
                  <span class="tag-item">{{ item.specialTopicName }}</span>
                </nuxt-link>
              </div>
            </div>
          </div>
          <div
            v-if="false"
            class="evaluate">
            <p class="evaluate_left">
              <i class="el-icon-evaluate"></i>
              <span>我要评价</span>
            </p>
            <p
              class="evaluate_right row-flex ac"
              @click="showEva()">
              <span>查看我的评价</span>
              <!-- <ArrowRight :size="16" /> -->
              <el-icon>
                <ArrowRight />
              </el-icon>
            </p>
          </div>
          <div
            v-if="false"
            class="read_tip">
            <div class="tip_tit">
              <p class="tit_left">
                <i class="el-icon-careful"></i>
                <span>会刊小贴士</span>
              </p>
              <p
                v-if="$get(globalStore, 'user', null)"
                class="tit_right">
                <i class="el-icon-integral"></i>
                <span>目前积分：{{ $get(globalStore, 'user.credit', '0') }}</span>
              </p>
            </div>
            <div class="tip_content">
              <img
                alt="展会"
                rel="nofollow,noindex"
                src="assets/images/noInfo.png" />
              <p>
                分享展会资讯可获得
                <span>积分</span>
                哦！攒够积分即可下载会刊
              </p>
            </div>
          </div>
          <div
            v-if="detail.averageScore > 0"
            class="comment_content">
            <div class="comment">
              <p class="evaluate_left">
                <i class="el-icon-redZan"></i>
                <span>评价</span>
              </p>
              <div class="evaluate_right">
                <span class="sub_num">{{ detail.averageScore }}</span>
                <el-rate
                  v-model="detail.averageScore"
                  disabled></el-rate>
              </div>
            </div>
            <div class="comment_list">
              <div class="comment_item">
                <div class="label">主办方背景</div>
                <div class="progress">
                  <el-progress
                    :format="format"
                    :percentage="detail.hostScore * 20"
                    :stroke-width="8" />
                </div>
              </div>
              <div class="comment_item">
                <div class="label">展会专业水平</div>
                <div class="progress">
                  <el-progress
                    :format="format"
                    :percentage="detail.exhibitionScore * 20"
                    :stroke-width="8"></el-progress>
                </div>
              </div>
              <div class="comment_item">
                <div class="label">观众专业水平</div>
                <div class="progress">
                  <el-progress
                    :format="format"
                    :percentage="detail.audienceScore * 20"
                    :stroke-width="8"></el-progress>
                </div>
              </div>
              <div class="comment_item">
                <div class="label">展商专业水平</div>
                <div class="progress">
                  <el-progress
                    :format="format"
                    :percentage="detail.exhibitorScore * 20"
                    :stroke-width="8"></el-progress>
                </div>
              </div>
              <div class="comment_item">
                <div class="label">展会影响力</div>
                <div class="progress">
                  <el-progress
                    :format="format"
                    :percentage="detail.effectScore * 20"
                    :stroke-width="8"></el-progress>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 系列展会 -->
      <div
        v-if="$get(logoFair, 'records', []).length > 0"
        class="series_exh">
        <section-title
          :title="`${detail.exhibitionName}系列展会`"
          h2 />
        <div class="exh_list">
          <fair-item
            v-for="item in $get(logoFair, 'records', [])"
            :key="item.exhibitionId"
            :item="item" />
        </div>
      </div>
      <!-- 行业展会 -->
      <div
        v-if="$get(industryFair, 'records', []).length > 0"
        class="recommend_exh">
        <div class="title_more">
          <section-title
            :title="`${$get(industry, '[0].name', '')}${$t('common.fair')}`"
            h2
            style="font-size: 20px; font-weight: bold" />
          <p class="more">
            <nuxt-link
              :title="`${$get(industry, '[0].name', '')} ${$t('common.fair')}`"
              :to="`/exhibition-${detail.firstIndustryId}-${detail.industry1}-0-0-0-0-1/`"
              target="_blank">
              {{ $t('common.more') }}
            </nuxt-link>
            <ArrowRight />
          </p>
        </div>
        <div class="recommend_exh_list">
          <Goods
            v-for="item in $get(industryFair, 'records', [])"
            :key="item.exhibitionId"
            :data="item"
            class="exh_item" />
        </div>
      </div>
      <!-- 展会资讯 -->
      <div
        v-if="fairNews.length > 0"
        class="recommend_exh industry-news-box">
        <div class="industry-news-box__header title_more">
          <section-title
            :title="`${$get(detail, 'exhibitionName', '')}${$t('menu.exhibitionInfo')}`"
            h2
            style="font-size: 20px; font-weight: bold" />
          <p class="more">
            <!-- <nuxt-link
              :to="`/exhibition-${detail.firstIndustryId}-${detail.industry1}-0-0-0-0-1/`"
              :title="`${$get(industry, '[0].name', '')} ${$t('common.fair')}`"
              target="_blank"
            >
              $t('common.more')
            </nuxt-link> -->
            <a
              style="cursor: pointer"
              @click="goToInformation()">
              {{ $t('common.more') }}
            </a>
            <ArrowRight />
          </p>
        </div>
        <div class="industry-news-box__top">
          <NewsItem2
            v-for="item in fairNews.slice(0, 4)"
            :key="item.newsId"
            :news="item" />
        </div>
        <div class="news-list">
          <nuxt-link
            v-for="item in fairNews.slice(4, 13)"
            :key="item.newsId"
            :to="handleNewsUrl(item.viewUrl, item.newsId)"
            class="news-item"
            target="_blank">
            {{ item.newsName }}
          </nuxt-link>
        </div>
      </div>

      <div
        v-if="news.length > 0"
        class="recommend_exh industry-news-box">
        <div class="industry-news-box__header title_more">
          <section-title
            :title="`${$get(industry, '[0].name', '')}${$t('menu.exhibitionInfo')}`"
            h2
            style="font-size: 20px; font-weight: bold" />
          <p class="more">
            <nuxt-link
              :title="`${$get(industry, '[0].name', '')} ${$t('common.fair')}`"
              :to="`/information-1-${detail.industry1}-1/`"
              target="_blank">
              {{ $t('common.more') }}
            </nuxt-link>

            <ArrowRight />
          </p>
        </div>
        <div class="industry-news-box__top">
          <NewsItem2
            v-for="item in news.slice(0, 4)"
            :key="item.newsId"
            :news="item" />
        </div>
        <div class="news-list">
          <nuxt-link
            v-for="item in news.slice(4, 13)"
            :key="item.newsId"
            :to="handleNewsUrl(item.viewUrl, item.newsId)"
            class="news-item"
            target="_blank">
            {{ item.newsName }}
          </nuxt-link>
        </div>
      </div>
      <!--下线-->
      <div
        v-if="false"
        class="footer-new-card">
        <new-item
          v-if="newNews.length > 0"
          :list="newNews"
          title="最新展会资讯"
          more="/information/" />
        <new-item
          v-if="news.length > 0"
          :list="news"
          :more="`/information-1-${$get(industry, '[0].id', '')}-1/`"
          :title="`${$get(industry, '[0].name', '')} ${$t('menu.exhibitionInfo')}`" />
        <new-item
          v-if="fairNews.length > 0"
          :list="fairNews"
          :more="`/information-1-${$get(industry, '[0].id', '')}-1/`"
          :title="`${$get(detail, 'exhibitionName', '')} ${$t('menu.exhibitionInfo')}`" />
        <new-item
          v-else-if="newFair.length > 0"
          :list="newFair"
          more="/exhibition/"
          title="最新展会"
          type="fair" />
      </div>
      <div class="hot_country">
        <div class="tab_head row-flex">
          <div
            :class="{ active: innerChainActive == 0 }"
            class="tab_name"
            @click="handleHotTab(0)">
            {{ $t('innerChain.hotArea') }}
          </div>
          <div
            :class="{ active: innerChainActive == 1 }"
            class="tab_name"
            @click="handleHotTab(1)">
            {{ $t('innerChain.hotIndustry') }}
          </div>
          <div
            :class="{ active: innerChainActive == 2 }"
            class="tab_name"
            @click="handleHotTab(2)">
            {{ $t('innerChain.hotExhibition') }}
          </div>
        </div>
        <div class="country_list">
          <div
            v-show="innerChainActive == 0"
            class="tab_content row-flex-wrap">
            <a
              v-for="item in innerChainAreaList"
              :key="item.id"
              :href="item.url"
              :title="item.content"
              target="_blank">
              {{ item.content }}
            </a>
          </div>
          <div
            v-show="innerChainActive == 1"
            class="tab_content row-flex-wrap">
            <a
              v-for="item in innerChainIndustryList"
              :key="item.id"
              :href="item.url"
              :title="item.content"
              target="_blank">
              {{ item.content }}
            </a>
          </div>
          <div
            v-show="innerChainActive == 2"
            class="tab_content row-flex-wrap">
            <a
              v-for="item in innerChainExhList"
              :key="item.id"
              :href="item.url"
              :title="item.content"
              target="_blank">
              {{ item.content }}
            </a>
          </div>
        </div>
      </div>
      <el-dialog
        :before-close="closeVideo"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        v-model="videoVisible"
        class="video_dialog"
        width="800px">
        <div
          class="close_icon"
          @click="closeVideo">
          <Close />
        </div>
        <div
          id="J_prismPlayer"
          v-loading="isLoading"
          class="video-player"></div>
      </el-dialog>

      <!-- 申请和下载 -->
      <el-dialog
        :before-close="handleClose"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :title="applyTitle"
        v-model="applyVisible"
        class="join-dialog"
        destroy-on-close
        width="30%">
        <div
          class="box"
          style="text-align: center">
          <el-form
            ref="ruleRef"
            :model="ruleForm"
            :rules="rules">
            <el-form-item prop="companyName">
              <el-autocomplete
                v-model="ruleForm.companyName"
                :fetch-suggestions="querySearchAsync"
                :placeholder="$t('exhibitionDetail.form1.companyName')"
                clearable
                style="width: 100%"></el-autocomplete>
            </el-form-item>
            <el-form-item prop="linkman">
              <el-input
                v-model="ruleForm.linkman"
                :placeholder="$t('exhibitionDetail.form1.name')"
                clearable
                style="width: 100%"></el-input>
            </el-form-item>
            <el-form-item
              class="_fun-hide"
              prop="linkmanPhoneNumber">
              <el-input
                v-model="ruleForm.linkmanPhoneNumber"
                :placeholder="$t('exhibitionDetail.form1.phone')"
                clearable
                style="width: 100%"></el-input>
            </el-form-item>

            <el-form-item class="_fun-hide">
              <el-input
                v-model="ruleForm.email"
                :placeholder="$t('exhibitionDetail.form1.email')"
                clearable
                style="width: 100%"></el-input>
            </el-form-item>
            <el-form-item class="_fun-hide">
              <el-input
                v-model="ruleForm.remark"
                :placeholder="$t('exhibitionDetail.form1.remark')"
                clearable
                style="width: 100%"></el-input>
            </el-form-item>
          </el-form>
        </div>

        <template #footer>
          <span class="dialog-footer">
            <el-button @click="resetForm(ruleRef)">
              {{ $t('exhibitionDetail.form1.cancel') }}
            </el-button>
            <el-button
              type="primary"
              @click="submit(ruleRef)">
              {{ $t('exhibitionDetail.form1.submit') }}
            </el-button>
          </span>
        </template>
      </el-dialog>

      <!-- 小程序二维码弹窗 -->
      <el-dialog
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :title="dialogTitle"
        v-model="dialogShow"
        append-to-body
        class="preview-component"
        destroy-on-close
        width="400px">
        <img
          :alt="dialogTitle"
          :src="dialogImg"
          rel="nofollow,noindex" />
        <div class="desc">{{ $t('footer.desc') }}</div>
      </el-dialog>

      <el-dialog
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :show-close="false"
        v-model="reptileShow"
        append-to-body
        class="preview-component"
        title="通知"
        width="400px">
        <div class="messageTitle">
          {{ messageTitle }}
        </div>
      </el-dialog>

      <!-- 地图 -->
      <el-dialog
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        v-model="mapDialogShow"
        append-to-body
        class="map-component"
        destroy-on-close
        width="1200px">
        <div
          slot="title"
          class="dialog-header">
          <p class="map_name">
            <!-- {{
              detail.regionType == 1
                ? $get(detail, 'pavilionInfo.pavilionEnglishName')
                : $get(detail, 'pavilionInfo.pavilionName', '')
            }} -->
            <template v-if="!lang || lang == 'cn'">
              {{
                detail.regionType == 1
                  ? $get(detail, 'pavilionInfo.pavilionEnglishName')
                  : $get(detail, 'pavilionInfo.pavilionName', '')
              }}
            </template>
            <template v-else>
              {{ $get(detail, 'pavilionInfo.pavilionEnglishName') }}
            </template>
          </p>
          <p class="map_arres">
            <template v-if="!lang || lang == 'cn'">
              {{
                $get(detail, 'pavilionInfo.pavilionAddress', '') ||
                $get(detail, 'pavilionInfo.pavilionEnglishAddress', '')
              }}
            </template>
            <template v-else>
              {{ $get(detail, 'pavilionInfo.pavilionEnglishAddress', '') }}
            </template>
          </p>
        </div>
        <div class="desc">
          <ju-map
            :attribution="attribution"
            :center="center"
            :detail="detail.pavilionInfo"
            :height="600"
            :width="1200" />
        </div>
      </el-dialog>
      <Poster
        :info="detail"
        v-model="showPoster"></Poster>
      <DialogSubsidy
        :dialogVisible="showSubsidy"
        :exhibitionId="detail.exhibitionId"></DialogSubsidy>
      <rightFloat
        :serviceListAllData="serviceListAll"
        :lang="lang"></rightFloat>
      <el-dialog
        v-model="focusQrcode"
        class="follow_dialog"
        :show-close="false"
        width="700px">
        <div class="focus_qrcode_box">
          <img
            @click="focusQrcode = false"
            class="close_icon2"
            src="~/assets/images/Shape.png" />
          <div class="focus_qrcode_header">
            <div class="success_text">展会关注成功</div>
            <div class="guidance">
              可前往
              <span @click="toExpouser">「关注的展会」</span>
              查看
            </div>
          </div>
          <div class="qrcode_All">
            <div class="qrcode_left">
              <div class="qrcode_box">
                <img src="~/assets/images/qrcode.jpg" />
              </div>
              <div class="scanCodeTip">关注聚展微信公众号</div>
              <div class="fousInfo">第一时间接收展会信息,</div>
              <div class="fousInfo">获取优惠新资讯</div>
            </div>
            <div class="qrcode_left qrcode_right">
              <div class="qrcode_box">
                <img
                  v-if="qrcodeMiniUrl"
                  :src="qrcodeMiniUrl" />
                <img
                  v-else
                  src="~/assets/images/juzhan-mini.jpg" />
              </div>
              <div class="scanCodeTip">添加聚展小程序</div>
              <div class="fousInfo">手机扫码交易更便捷,</div>
              <div class="fousInfo">订单查询更便捷</div>
            </div>
          </div>
        </div>
      </el-dialog>
      <!-- 底部浮框 -->
      <div class="footer-float">
        <div class="float_box">
          <div class="float_content_box">
            <img
              :src="logo(detail.pic)"
              :alt="detail.exhibitionName" />
            <div class="float-exhibition-box">
              <div class="float-exhibition-info">
                <p class="info_name ellipsis">{{ detail.exhibitionName }}</p>
                <!-- <p class="info_time" style="line-height:12px" v-if="detail.dynamic == 2">
                  <span v-if="isLogin">
                        {{ newDateFormat(detail)}}
                      </span>
                      <span v-else @click="shouldLogin">
                        {{ detail.lunchTime.substring(0, 7) }}...{{
                          $t('exhibitionDetail.viewTime')
                        }}
                      </span>
                </p> -->
                <p
                  class="info_time"
                  style="line-height: 12px">
                  <span v-if="isLogin">
                    {{ detail.lunchTime }}
                  </span>
                  <span
                    v-else
                    @click="shouldLogin">
                    {{ detail.lunchTime.substring(0, 7) }}...{{ $t('exhibitionDetail.viewTime') }}
                  </span>
                </p>
                <p
                  class="info_price"
                  v-if="detail.ticket.isFreeTicket !== 1">
                  <span>门票折扣价：</span>
                  <span
                    class="price_value"
                    v-if="detail.minPrice || detail.minPrice === 0">
                    ¥{{ detail.minPrice }}
                  </span>
                  <span
                    class="price_value"
                    v-else>
                    无票
                  </span>
                  <span v-if="detail.marketPrice || detail.marketPrice === 0">原价:</span>
                  <span
                    class="original_price"
                    v-if="detail.marketPrice || detail.marketPrice === 0">
                    ￥{{ detail.marketPrice }}
                  </span>
                </p>
              </div>
              <div class="control-btn">
                <div
                  class="btn_text"
                  @click="handleToTicket">
                  {{
                    detail.ticket.isFreeTicket === 1
                      ? $t('exhibitionDetail.freeForALimitedTime')
                      : $t('exhibitionDetail.ticketReservation')
                  }}
                </div>
                <div
                  @click="handleApply()"
                  class="btn_text">
                  {{ $t('exhibitionDetail.boothApply') }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </NuxtLayout>
</template>

<script lang="ts" setup>
  import xss from 'xss'
  import { blackList } from '~/utils/blackFair'
  import { ElForm } from 'element-plus'
  import {
    getContent,
    getWebp,
    getXOssProcess,
    handleNewsUrl,
    handleCheckUrl
  } from '~/utils/common'
  import { Swiper, SwiperSlide } from 'swiper/vue'
  import 'swiper/swiper-bundle.css'
  import Wei2 from 'assets/icon/wei2.png'
  import ContentBg from 'assets/images/content_bg.webp'
  import Logo from 'assets/logo/logo.png'
  import { ArrowRight, Close } from '@element-plus/icons-vue'
  import { useFairDetail } from '~/composables/fair/useFairDetail'
  import { ELocale } from '~/types/enums'

  const SectionTitle = defineAsyncComponent(() => import('~/components/SectionTitle/index.vue'))
  const FairItem = defineAsyncComponent(() => import('~/views/home/components/FairItem.vue'))
  const Booth = defineAsyncComponent(() => import('~/views/fair/components/booth.vue'))
  const Route = defineAsyncComponent(() => import('~/views/fair/components/Route.vue'))
  const NewItem = defineAsyncComponent(() => import('~/views/fair/components/newItem.vue'))
  const JuMap = defineAsyncComponent({
    // 加载函数
    loader: () => import('~/components/Map/index.vue'),
    delay: 800
  })
  //
  // defineAsyncComponent(() => import(''))
  const MediaBox = defineAsyncComponent(() => import('~/components/MediaBox/index.vue'))
  const FairTag = defineAsyncComponent(() => import('~/components/Goods/fairTag.vue'))
  const FairUser = defineAsyncComponent(() => import('~/components/FairUser/index.vue'))
  const Poster = defineAsyncComponent(() => import('~/views/fair/components/poster.vue'))
  const rightFloat = defineAsyncComponent(() => import('~/views/fair/components/rightFloat.vue'))
  const ResourceView = defineAsyncComponent(
    () => import('~/views/fair/components/resourceView.vue')
  )
  const DialogSubsidy = defineAsyncComponent(
    () => import('~/views/fair/components/dialogSubsidy.vue')
  )
  const NewsItem2 = defineAsyncComponent(() => import('~/views/fair/components/NewsItem2.vue'))
  const Goods = defineAsyncComponent(() => import('~/components/Goods/index.vue'))

  const {
    detail,
    route,
    booth,
    lang,
    sameFair,
    isLogin,
    tips,
    showMessage,
    messageList,
    datePosition,
    headimg,
    rateValue,
    rateData,
    sessionsFair,
    showTitle,
    routeHash,
    current,
    showView,
    resourceList,
    photos,
    activeName,
    industryList,
    newPeriodical,
    hasPhoneOrEmail,
    industryFair,
    sameSwiperOption,
    areaExhList,
    downloadList,
    boothServiceList,
    ticketServiceList,
    banner,
    pavilionPicture,
    attribution,
    center,
    follow,
    remind,
    tag,
    globalStore,
    logoFair,
    industry,
    fairNews,
    news,
    newNews,
    newFair,
    innerChainActive,
    innerChainAreaList,
    innerChainIndustryList,
    innerChainExhList,
    videoVisible,
    isLoading,
    applyTitle,
    applyVisible,
    ruleForm,
    rules,
    ruleRef,
    dialogTitle,
    dialogShow,
    dialogImg,
    reptileShow,
    messageTitle,
    mapDialogShow,
    showPoster,
    showSubsidy,
    shouldLogin,
    newDateFormat,
    getAddress,
    formatNumber,
    handleApply,
    handleSubsidy,
    toExposer,
    industryFilter,
    setNavIndustry,
    getPercent,
    handleToTicket,
    toExhibitionDel,
    setCurrent,
    handleShowMini,
    getBusiness,
    handleView,
    handlePoster,
    handleContent,
    openVideo,
    handlePreview,
    handleClick,
    readPeriodical,
    apply,
    handleOnlineService,
    toCommunity,
    handleRemind,
    showEva,
    format,
    goToInformation,
    handleHotTab,
    closeVideo,
    handleClose,
    querySearchAsync,
    resetForm,
    submit,
    logo,
    $t,
    $get,
    periodicalList,
    exhibitorData,
    hasOrder,
    getCompanyName,
    toCompanyDetail,
    isFocus,
    handleFollowFair,
    qrcodeMiniUrl,
    focusQrcode,
    serviceListAll,
    toExpouser
  } = await useFairDetail(ELocale.cn)

  useHead(() => {
    const {
      exhibitionId,
      lunchTime,
      exhibitionName,
      exhibitionEnglishName,
      pavilionInfo,
      organizer,
      pic,
      industry = ''
    } = detail.value
    const { areaName, pavilionAddress } = pavilionInfo || {}
    const _year = lunchTime?.slice(0, 4)
    const yearMonth = lunchTime?.slice(0, 7) // 年月

    const _keyword = []
    const nameEn = exhibitionEnglishName?.trim() || ''
    try {
      _keyword.push(nameEn)
      const industryList = industry?.split(',') || []
      industryList.forEach((name: string) => {
        _keyword.push(`${areaName}${name}${$t('tdk.exhibitionDetail.keyword1')}`)
        _keyword.push(`${areaName}${name}${$t('tdk.exhibitionDetail.keyword2')}`)
        _keyword.push(`${areaName}${name}${$t('tdk.exhibitionDetail.keyword3')}`)
        _keyword.push(`${areaName}${name}${$t('tdk.exhibitionDetail.keyword4')}`)
        _keyword.push(`${areaName}${name}${$t('tdk.exhibitionDetail.keyword5')}`)
      })
    } catch (error) {
      //   console.error(error);
    }
    const keywords = _keyword.join(',')
    let cover = Logo
    try {
      cover = JSON.parse(pic)[0]
    } catch (error) {
      //   console.error(error);
      cover = Logo
    }
    const title = `${exhibitionName}${_year}_${$t('tdk.ticket')}_${$t('tdk.time')}_${$t('tdk.magazine')}-${$t('tdk.jufair')}`
    const description = `${$t('tdk.fairTime')}:${yearMonth},${$t('tdk.address')}:${pavilionAddress},${$t('tdk.sponsor')}:${organizer},${$t('tdk.exhibitionDetail.description')}.`
    const aliplayer = 'https://g.alicdn.com/de/prismplayer/2.9.3/skins/default/aliplayer-min.css'

    return {
      title,
      meta: [
        {
          name: 'mobile-agent',
          'http-equiv': 'mobile-agent',
          content: `format=html5; url=https://m.jufair.com/exhibition/${exhibitionId}.html`
        },
        { name: 'keywords', content: keywords },
        { name: 'description', content: description },
        { name: 'og:type', content: 'product' },
        { name: 'og:image', content: cover },
        { name: 'og:title', content: title },
        { name: 'og:description', content: description },
        { name: 'og:url', content: `https://www.jufair.com${route.path}` },
        { name: 'og:product:price', content: booth.value.boothPrice1 },
        { name: 'og:product:category', content: `${industry}${$t('common.fair')}` },
        {
          name: 'og:product:nick',
          content: `name=${$t('tdk.jufair')}; url= https://www.jufair.com${route.path}`
        }
      ],
      // link: [{ rel: 'stylesheet', href: aliplayer }], // 播放器(展会介绍上方视频播放器)
      script: [
        {
          type: 'text/javascript',
          src: 'https://g.alicdn.com/de/prismplayer/2.9.3/aliplayer-min.js',
          async: true // defer
        }
      ]
    }
  })
</script>

<style lang="less">
  .map-component {
    padding: 0;

    .dialog-header {
      text-align: center;

      .map_name {
        font-size: 20px;
        font-weight: 800;
      }

      .map_arres {
        margin-top: 10px;
      }
    }

    .el-dialog {
      border-radius: 8px;
    }

    .el-dialog__close {
      font-size: 22px;
    }

    .el-dialog__body {
      padding: 0 !important;
      text-align: center;
    }

    .desc {
      color: #333;
      text-align: center;
    }
  }

  .video_dialog {
    height: 450px;
    margin-top: 0 !important;
    top: calc(50% - 225px);

    .close_icon {
      cursor: pointer;
      position: absolute;
      top: -26px;
      right: -26px;
      width: 30px;
      height: 30px;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      background: #fff;
      color: #333;
      font-size: 20px;

      svg {
        width: 20px;
        height: 20px;
      }
    }

    .video-player {
      position: relative;
      height: 100%;
    }

    .el-dialog__header {
      display: none;
    }

    .el-dialog__body {
      height: 100%;
      padding: 10px;
    }
  }

  .messageTitle {
    font-size: 20px;
    font-weight: 800;
    margin-bottom: 20px;
  }

  .leaflet-control-attribution,
  .leaflet-control {
    a {
      display: none;
    }
  }

  .introduction_exh,
  .exh_range {
    p {
      font-size: 16px;
      color: #333;
      line-height: 1.8;
      margin-top: 13px;
      margin-bottom: 16px;
      letter-spacing: 1px;
      text-align: justify;
    }

    img {
      display: block;
      max-width: 100%;
      margin: 0 auto;
    }
  }

  .exh_range {
    p {
      margin: 8px 0;
    }
  }

  .exh_detail_tabs_content {
    .el-tabs__header {
      margin: 0;
      padding: 20px 32px 15px 27px;
      background-color: #fff;
      border-radius: 6px 6px 0 0;

      .el-tabs__nav-wrap::after {
        background: transparent;
      }
    }

    .el-tabs__item {
      font-size: 18px;
    }
  }

  // 同期展会
  .same-exh-area {
    width: 1190px;
    margin: 0 auto;

    .same-exh-list {
      display: flex;
      flex-direction: row;

      .same-exh-item,
      .same-exh {
        width: 230px;
      }

      .same-exh-item {
        margin-bottom: 4px;
      }

      .same-exh {
        height: auto;
      }
    }
  }

  .same-Replenishment {
    position: relative;
    width: 1190px;
    margin: 0 auto;

    .replenishment-ul {
      display: flex;
      flex-wrap: wrap;
      overflow: hidden;
      height: 192px;
      margin-bottom: 5px;

      .replenishment-li {
        width: 362px;
        margin-right: 10px;
      }

      .template_box {
        margin-left: 30px;
        overflow: hidden;
        width: 362px;

        &.moreHeight {
          width: 740px;
        }
      }
    }

    .lessLeft {
      position: absolute;
      top: 0;
      left: 405px;
    }

    .moreLeft {
      position: absolute;
      top: 0;
      left: 775px;
    }
  }

  .industry-exh {
    // width: 854px;
    width: 1190px;
    margin: 0 auto;

    .same-exh-list {
      display: flex;
      flex-direction: row;

      .same-exh-item,
      .same-exh {
        width: 230px;
      }

      .same-exh-item {
        margin-bottom: 4px;
        width: 370px !important;
      }

      .same-exh {
        height: auto;
      }
    }
  }

  .medium_list,
  .same-exh-area {
    .swiper-container {
      width: 100%;
    }
  }
</style>
<style lang="less" scoped>
  .exh_detail-container {
    .top_bg {
      min-height: 500px;
      margin: 15px 0 19px 0;
      background-color: #13171d;
      //background: url('assets/images/fair-head.png') no-repeat;
      // background-size: 830px 786px;
      background-size: cover;
      background-repeat: no-repeat;
      position: relative;

      .back_image {
        position: absolute;
        z-index: 1;
        left: 0;
        top: 0;
      }

      .video-box {
        position: absolute;
        z-index: 9;
        width: 100%;
        top: 0;
        height: 100%;
        overflow: hidden;
        display: flex;
        align-items: center;

        .bg-video {
          width: 100%;
          height: fit-content;
          background: #000;
        }
      }

      .top_content {
        width: 1190px;
        margin: 0 auto;
        padding: 20px 0 29px 0;
        position: relative;
        z-index: 10;

        .brand {
          font-size: 14px;
          color: #fff;
          line-height: 16px;
          margin-bottom: 32px;
          background: rgba(0, 0, 0, 0.45);
          padding: 8px;
          border-radius: 4px;
          display: flex;

          a {
            font-size: 14px;
            color: #fff;
          }

          svg {
            width: 14px;
          }
        }

        .exh_detail_basic_info {
          display: flex;
          background: rgba(0, 0, 0, 0.45);
          padding: 24px 24px 0 24px;
          border-radius: 4px;
          position: relative;

          .fair-cover {
            width: 282px;
            height: 167px;
            flex-shrink: 0;
            // background: #efefef;
            border-radius: 4px;
            // border: 1px solid #d0d0d0;
            margin-right: 30px;
            display: flex;
            justify-content: center;
            align-items: center;
            overflow: hidden;

            img {
              width: 282px;
              height: 167px;
              // object-fit: contain;
              object-fit: cover;
            }
          }

          .exh_detail_right {
            width: 558px;
            display: flex;
            flex-direction: column;
            flex-shrink: 0;
            // flex: 1;
            position: relative;
            margin-right: 30px;
            margin-bottom: 15px;

            .sessions-tag {
              position: absolute;
              right: 0;
              top: 0;
              width: 70px;
              height: 80px;
              padding-bottom: 18px;
              background: url('https://dcdn-jufair-test.jufair.com/jufair/6dNbzXfEe3eBRSpCcyG7dDiQSWcmeFZj.jpg')
                no-repeat;
              background-size: 100% auto;

              .unit {
                position: absolute;
                right: 16px;
                top: 17px;
                font-size: 12px;
              }
            }

            .detail_name {
              // padding-right: 10px;
              font-size: 22px;
              font-weight: bold;
              color: #fff;
              line-height: 26px;
              margin-bottom: 7px;
              display: flex;
              align-items: flex-start;

              h1 {
                font-size: 24px;
                font-weight: bold;
                color: #fff;
                line-height: 26px;
              }

              .tag {
                height: 22px;
                line-height: 22px;
                font-style: normal;
                font-size: 14px;
                border-radius: 4px;
                padding: 0 6px;
                color: #fff;
                margin-right: 6px;
                margin-top: 3px;
                flex-shrink: 0;
              }

              .tag[data-tag='推荐'] {
                background: linear-gradient(#ff6337, #ff381a);
              }

              .tag[data-tag='精选'] {
                background: linear-gradient(#39dd80, #1cb84a);
              }

              .tag[data-tag='热门'] {
                background: linear-gradient(#37b0fe, #1d7cfe);
              }

              .session {
                background: linear-gradient(180deg, #ffa20f 0%, #ff5110 100%);
              }
            }

            .del {
              display: block;
              color: #999 !important;
              text-decoration: line-through;

              div {
                text-decoration: line-through;
              }
            }

            .weight {
              font-weight: bold;
            }

            .new-date {
              display: flex;
              align-items: center;

              .el-icon-xin {
                margin-right: 6px;
              }
            }

            .detail_en {
              font-size: 20px;
              font-weight: 600;
              color: #fff;
              line-height: 26px;
              margin-bottom: 16px;
            }

            /* 同期展会 */

            .same_time_exh {
              padding: 10px 16px;
              width: 629px;
              background: rgba(23, 23, 23, 0.55);
              border-radius: 6px;
              display: flex;

              .same_tit {
                font-size: 16px;
                font-weight: bold;
                color: #fff;
                line-height: 22px;
              }

              .same_list {
                a {
                  display: block;
                  font-size: 16px;
                  font-weight: bold;
                  color: #d7fffd;
                  line-height: 22px;
                  margin-bottom: 11px;

                  &:last-child {
                    margin-bottom: 0;
                  }
                }
              }
            }

            .exh_close {
              // margin-right: 8px;
              // width: 74px;
              // height: 26px;
              // background: url('assets/icon/closeExh.png') no-repeat;
            }

            .exh_change {
              // margin-right: 8px;
              // width: 100px;
              // height: 26px;
              // background: url('assets/icon/timeChange.png') no-repeat;
            }

            .exh_delay {
              margin-right: 5px;
              width: 60px;
              height: 17px;
              text-align: center;
              line-height: 17px;
              font-size: 12px;
              color: #fff;
              background: rgba(255, 255, 255, 0.2);
              border-radius: 4px;
              text-decoration: none;
            }

            .line {
              font-size: 14px;
              color: #fff;
              line-height: 34px;
              display: flex;
              align-items: center;

              &.line-wrap {
                display: flex;
                flex-direction: row;
                flex-wrap: wrap;
              }

              .boothPrice2 {
                margin-left: 20px;
                border: 1px solid #fff;
                padding: 0 6px 0 6px;
                border-radius: 4px;
                max-width: 296px;
                background: #fae3e3;
                overflow: hidden; /* 隐藏溢出内容 */
                text-overflow: ellipsis; /* 使用省略号表示溢出的文本 */
                white-space: nowrap; /* 防止文本换行 */
                color: red;
                line-height: 26px;
              }

              .boothPrice1 {
                border: 1px solid #fff;
                padding: 0 6px 0 6px;
                border-radius: 4px;
                max-width: 296px;
                background: #fae3e3;
                overflow: hidden; /* 隐藏溢出内容 */
                text-overflow: ellipsis; /* 使用省略号表示溢出的文本 */
                white-space: nowrap; /* 防止文本换行 */
                color: red;
                line-height: 26px;
              }

              .line_point {
                border: 1px solid #fff;
                padding: 0 6px 0 6px;
                border-radius: 4px;
                background-color: #fff;
                border-color: #d9ecff;
                overflow: hidden; /* 隐藏溢出内容 */
                text-overflow: ellipsis; /* 使用省略号表示溢出的文本 */
                white-space: nowrap; /* 防止文本换行 */
                color: #409eff;
                margin-left: 4px;
                font-size: 12px;
                line-height: 18px;
                height: 20px;
                opacity: 0.78;

                &:nth-child(1) {
                  margin-left: 0;
                }
              }

              &.line-width {
                width: 580px;
              }

              .address {
                margin-left: 10px;
                min-width: 60px;
                height: 20px;
                border: 1px solid #fff;
                text-align: center;
                padding: 0 6px 0 6px;
                border-radius: 6px;
                cursor: pointer;
                font-size: 14px;
                line-height: 20px;
              }

              .line_label {
                display: inline-block;
                min-width: 70px;
                text-align: right;
                margin-right: 13px;
                font-weight: bold;
                white-space: nowrap;
              }

              .line-item {
                .line_label {
                  margin: 0;
                }

                &.line-button {
                  &:hover {
                    cursor: pointer;
                  }
                }
              }

              .line_value {
                text-overflow: ellipsis;
                overflow: hidden;
                line-height: 20px;

                a {
                  color: #fff;
                }
              }

              .get-price {
                text-decoration: underline;
                cursor: pointer;
              }

              .date {
                font-size: 20px;
                margin: 0 15px 0 4px;
              }
            }
          }

          .top__r {
            width: 250px;
            // display: flex;
            // flex-direction: column;
            // justify-content: flex-end;
            position: relative;
            margin: -6px;
            margin-top: 25px;
            margin-bottom: 20px;

            .free-tag {
              min-width: 146px;
              text-align: center;
              background: @app-color;
              color: #fff;
              font-family:
                PingFangSC-Medium,
                PingFang SC,
                sans-serif;
              font-size: 18px;
              font-weight: 400;
              border-radius: 4px;
              padding: 8px 16px;
              letter-spacing: 1px;
              cursor: pointer;
              margin: 6px;
            }

            .tips-box {
              position: absolute;
              color: #fff;
              bottom: 0;
              right: 0;
              font-family:
                PingFangSC-Medium,
                PingFang SC,
                sans-serif;
              font-size: 16px;
              font-weight: bold;
            }

            .diff-days-wrap {
              margin: 8px;
              // margin-bottom: 90px;
              color: #fff;
              font-family:
                PingFangSC-Medium,
                PingFang SC,
                sans-serif;

              .diff-days-desc {
                font-size: 20px;
                font-weight: bold;
              }

              .diff-days-count {
                text-align: right;
                margin: 10px 0 0 0;

                .days {
                  font-size: 24px;
                  font-weight: bold;
                }

                .diff-unit {
                  font-size: 16px;
                  margin: 0 0 0 8px;
                }
              }
            }

            .sub-rate-box {
              color: white;
              border-bottom: 1px dashed #ddd;
              padding-bottom: 5px;

              .fl {
                float: left;
              }

              /deep/ .el-rate {
                .el-rate__icon {
                  margin-right: 0;
                  font-size: 15px;
                }
              }

              .rate {
                font-size: 35px;
                display: block;
                width: 75px;
                text-align: center;
                margin: 30px 0 0;
              }

              .rate-info {
                width: 170px;
                padding-left: 5px;
              }

              .info {
                li {
                  height: 20px;
                  line-height: 20px;
                  margin-bottom: 5px;

                  * {
                    display: inline-block;
                    vertical-align: middle;
                  }
                }

                .tit {
                  font-size: 14px;
                  // margin-right: 5px;
                }

                .progress {
                  width: 90px;
                  height: 7px;
                  background-color: #eee8dd;
                  border-radius: 2em;

                  .tag {
                    display: block;
                    height: 7px;
                    border-radius: 2em;
                    background-color: #ff925f;
                  }
                }
              }
            }
          }

          .transpond {
            width: 250px;
            height: 24px;
            display: flex;
            position: absolute;
            justify-content: end;
            top: 20px;
            right: 20px;

            img {
              width: 24px;
              height: 24px;
              margin-left: 12px;
              cursor: pointer;
            }
          }
        }

        .exh_detail_sessions {
          padding: 0 14px 24px 24px;
          background: rgba(0, 0, 0, 0.45);
          display: flex;
          flex-wrap: wrap;
          width: 100%;

          .item {
            margin-top: 10px;
            margin-right: 10px;
            border-radius: 4px;
            width: 49%;
            padding: 10px;
            background: #fff;
            display: flex;
            flex-wrap: wrap;
            align-items: center;
            cursor: pointer;

            &:nth-child(2n) {
              margin-right: 0;
            }

            .logo {
              width: 60px;
              text-align: center;

              .not-watermark {
                width: auto;
                height: 30px;
              }
            }

            .name {
              margin-left: 20px;
              width: 326px;
              white-space: nowrap;
              text-overflow: ellipsis;
              overflow: hidden;
              word-break: break-all;
            }

            .but {
              margin-left: 20px;
              text-align: center;
              background: #e50113;
              color: #fff;
              font-family:
                PingFangSC-Medium,
                PingFang SC,
                sans-serif;
              font-weight: 400;
              border-radius: 4px;
              padding: 6px;
              letter-spacing: 1px;
              cursor: pointer;
            }
          }
        }
      }
    }

    .download_box {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      height: 170px;
      margin-bottom: 10px;
      background: #fff;
      border-radius: 4px;

      .download_box_tag {
        position: relative;
        width: 402px;
        height: 130px;
        background-size: cover;
        background-position: center;
        background-repeat: no-repeat;
        margin-right: 10px;

        .bg_image {
          position: absolute;
          top: 0;
          left: 0;
          z-index: 1;
        }

        .download-content {
          position: relative;
          z-index: 2;
          margin: 36px 0 0 30px;

          .download-name {
            font-weight: bold;
            font-size: 22px;
            color: #ff3e68;
            line-height: 24px;
            margin-bottom: 12px;

            &.directory-name {
              color: #3888fa;
            }
          }

          .download-pay {
            width: 82px;
            height: 26px;
            background: rgba(112, 46, 212, 0);
            border-radius: 4px 4px 4px 4px;
            border: 1px solid #ff3e68;
            text-align: center;
            line-height: 26px;
            font-size: 12px;
            color: #ff3e68;
            cursor: pointer;

            &.directory-pay {
              color: #3888fa;
              border: 1px solid #3888fa;
            }
          }
        }
      }
    }

    .periodical-box {
      margin: 6px 0 8px 0;
      padding: 24px 32px 24px 27px;
      border-radius: 8px;
      background: #fff;

      .current-exhibitor-box {
        background: linear-gradient(#ffe8be 0%, #fff2d8 100%);
        height: 80px;
        width: 860px;
        margin-left: -32px;
        display: flex;
        align-items: center;

        img {
          width: 30px;
          height: 33px;
          margin-left: 57px;
        }

        .exhibitor-info {
          margin-left: 22px;
          // height: 47px;
          line-height: 24px;
          font-size: 16px;

          .exhibitor-name {
            font-weight: bold;
            color: #412b00;
            width: 340px;
          }

          .exhibitor-count {
            font-weight: 400;
            color: #b17300;
          }
        }

        .exhibitor-price {
          font-weight: bold;
          font-size: 24px;
          color: #ee0202;
          line-height: 30px;
          margin-left: 80px;
        }

        .exhibitor-buy {
          width: 110px;
          height: 36px;
          background: #ee0202;
          border-radius: 4px 4px 4px 4px;
          margin-left: 100px;
          font-size: 14px;
          color: #fff;
          text-align: center;
          line-height: 36px;
          cursor: pointer;
        }
      }

      .company-ul {
        margin-top: 20px;
        position: relative;

        .company-li {
          background: #f6f6f6;
          border-radius: 4px;
          min-height: 88px;
          overflow: hidden;
          margin-bottom: 10px;
          position: relative;
          cursor: pointer;

          .company-base {
            display: flex;
            margin-top: 15px;

            .company-icon {
              width: 48px;
              height: 48px;
              margin-left: 20px;
              background: #ff6160;
              color: #fff;
              border-radius: 10px;
              text-align: center;
              line-height: 48px;
            }

            .company-info {
              margin-left: 10px;
              height: 48px;
              display: flex;
              align-items: center;
              width: 450px;
              flex-wrap: wrap;

              .company-name {
                width: 100%;
                font-size: 16px;
                color: #333;
                line-height: 24px;
                margin-top: -4px;
              }

              .tag-list {
                display: flex;

                .tag-box {
                  padding: 0 5px;
                  height: 18px;
                  font-size: 12px;
                  background: #fff;
                  text-align: center;
                  line-height: 17px;
                  border-radius: 2px 2px 2px 2px;
                  border: 1px solid #8d42c6;
                  color: #8d42c6;
                  margin-right: 4px;

                  &.tag-2 {
                    border: 1px solid #999;
                    color: #999;
                  }

                  &.tag-3 {
                    border: 1px solid #f0612b;
                    color: #f1602a;
                  }

                  &.tag-4 {
                    border: 1px solid #19b8b8;
                    color: #19b8b8;
                  }
                }
              }
            }

            .booth-number {
              position: absolute;
              right: 20px;
              max-width: 300px;

              .number-text {
                font-weight: bold;
                font-size: 16px;
                color: #333;
              }
            }
          }

          .company-detail {
            margin: 7px 0;
            width: 100%;
            padding: 0 20px;
            font-size: 14px;
            color: #666;
            line-height: 24px;
            display: flex;
            justify-content: start;

            p {
              margin-right: 28px;
            }

            span {
              color: #333;
            }
          }

          &:hover {
            .company-name {
              span {
                color: red;
              }
            }

            .booth-number {
              span {
                color: red;
              }

              .number-text {
                color: red;
              }
            }
          }
        }

        .charge-box {
          width: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
          cursor: pointer;
          margin-top: 30px;

          .line {
            width: 240px;
            height: 0;
            border-top: 1.5px solid #ee0202;
          }

          .lock-text {
            font-size: 16px;
            color: #ee0202;
            margin: 0 10px;
          }
        }

        .charge-more {
          width: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
          cursor: pointer;

          .line {
            width: 240px;
            height: 0;
            border-top: 1.5px solid #ee0202;
          }

          .lock-text {
            font-size: 16px;
            color: #ee0202;
            margin: 0 10px;
          }
        }
      }
    }

    .content-section {
      padding: 24px 32px 24px 27px;
      background: #fff;
      margin-bottom: 12px;
      border-radius: 6px;
    }

    // 机票搜索
    /deep/ .air-ticket-search {
      .search-box-tabs {
        &.bottom {
          margin-bottom: 30px;
        }
      }

      .tab-content {
        padding: 16px;
      }

      .modify-search-v3 {
        height: 130px;
      }

      .flt-depart {
        //width: 170px;
      }

      .flt-arrival {
        //width: 170px;
      }

      .modify-search-v3 .form-item-v3-group .start-time-box {
        width: 244px;
      }

      .start-time-box {
        width: 180px;
      }

      .flt-date {
        width: 180px;
      }

      // 往返-日期选择
      .start-end-time-box {
        width: 375px;
      }

      .search-btn {
        bottom: -45px;
      }
    }

    .banner-tag {
      margin-bottom: 12px;

      > a {
        > img {
          width: 854px;
          border-radius: 6px;
        }
      }
    }

    .image_section {
      width: 854px;
      margin: 12px auto;
      padding: 0;
      background: transparent;
    }

    .medium_list {
      display: flex;
      margin-top: 13px;
      // margin-bottom: 44px;
      overflow-x: auto;

      .video-area {
        width: 260px;
        height: 200px;
        border-radius: 10px;
        // border: solid 1px #f6f6f6;
        overflow: hidden;
        margin-right: 10px;
        flex-shrink: 0;
        position: relative;
        background: #fff;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;

        .prism-player {
          display: flex;
          align-items: center;
          justify-content: center;
          background: #fff;

          img {
            width: 260px;
            height: auto;
          }

          .el-icon-bofang {
            position: absolute;
            left: 20px;
            bottom: 20px;
          }
        }
      }

      /deep/ .medium_item {
        width: 260px;
        height: 200px;
        flex-shrink: 0;
        border-radius: 10px;
        background: #f7f7f7;
        margin-right: 10px;
        overflow: hidden;
        // border: 1px solid #d9d9d9;
        box-sizing: border-box;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;

        .el-image {
          width: 260px;
          height: 200px;

          .el-image__inner,
          .el-image__preview {
            object-fit: cover;
          }
        }

        img {
          width: 260px;
          height: auto;
          min-height: 200px;
          border-radius: 10px;
        }
      }

      &::-webkit-scrollbar {
        display: none;
      }
    }

    .detail_content {
      display: flex;
      width: 1190px;
      margin: 0 auto;
      position: relative;

      .title_content {
        width: 82px;
        position: absolute;
        top: 287px;
        left: -86px;

        .title_list {
          position: sticky;
          top: 0;
          left: 0;
          background: #fff;
          border-radius: 8px;
          width: 82px;
          height: 272px;
          display: flex;
          justify-content: space-around;
          align-items: center;
          flex-flow: column;

          a {
            display: inline-block;
            font-size: 14px;
            color: #666;

            &:hover {
              color: #e50113;
            }
          }
        }
      }

      .detail_left {
        width: 854px;
        margin-right: 12px;

        .attention_box {
          display: flex;
          background: #fff;
          border-radius: 6px;
          padding: 12px 28px;

          .btn_font {
            margin-left: 4px;
          }

          .one,
          .two,
          .three,
          .four {
            height: 38px;
            border-radius: 6px;
            text-align: center;
            line-height: 38px;
            font-size: 16px;
            margin-right: 22px;
            cursor: pointer;
          }

          .one {
            // width: 82px;
            padding: 0 8px;
            background: #0086f6;
            color: #fff;
          }

          .follow {
            background: #d90029;
          }

          .two {
            // width: 182px;
            color: #fff;
            background: #34d668;
            position: relative;
            padding: 0 12px;
            display: flex;

            &:hover {
              .wechat-share {
                display: block;
              }
            }
          }

          .three {
            width: 124px;
            background: #e50113;
            color: #fff;
          }

          .four {
            // width: 82px;
            padding: 0 8px;
            background: #ccc;
            color: #5f5f5f;

            &.active {
              color: #fff;
              background: #e50113;
            }
          }

          .btn {
            width: 130px;
            height: 38px;
            text-align: center;
            line-height: 38px;
            font-size: 16px;
            border-radius: 4px;

            &:hover {
              cursor: pointer;
            }
          }

          .read {
            color: #e50113;
            border: 1px solid #e50113;
          }

          .hot-area {
            display: flex;
            margin-left: auto;
            align-items: center;
            font-size: 16px;

            img {
              width: auto;
              height: 18px;
              margin: 0 8px 0 0;
            }
          }

          .wechat-share {
            display: none;
            background: #fff;
            position: absolute;
            left: 50%;
            top: 38px;
            transform: translateX(-50%);
            z-index: 9;
            transition: 0.3s;
          }
        }

        .behalf-outer {
          background: #fff;
          margin: 12px 0;

          .behalf-inner {
            width: 100%;
            margin: 0 auto;
            background: #fff;

            img {
              width: 100%;
              height: auto;
              border-radius: 6px;
            }
          }
        }

        .exh_detail_tabs_content {
          margin-top: 12px;
          // padding: 34px 32px 40px 27px;
          // background: #fff;
          border-radius: 6px;

          .service-area {
            .service-item {
              display: flex;
              align-items: center;
              justify-content: space-between;
              margin-top: 20px;

              .service-left {
                display: flex;
                width: 270px;
              }

              .service-avatar {
                width: 70px;
                height: 70px;
                flex-shrink: 0;
                border-radius: 50%;
                overflow: hidden;

                img {
                  width: 70px;
                  height: 70px;
                  object-fit: cover;
                }
              }

              .service-info {
                padding: 10px 24px;

                .service-label {
                  font-size: 12px;
                  color: #849aae;
                  background: #f4f7f9;
                  padding: 4px 6px;
                  border-radius: 4px;
                }

                .service-name {
                  font-size: 16px;
                  font-weight: bold;
                }

                .service-desc {
                  font-size: 14px;
                  color: #333;
                  margin-top: 20px;
                }
              }

              .service-qrcode {
                display: flex;
                align-items: center;
                margin: 0 40px 0 0;
                position: relative;
                font-size: 14px;

                span {
                  padding-right: 0.5em;
                }

                .wechat-icon {
                  cursor: pointer;
                  width: 32px;

                  &:hover + .qrcode-area {
                    display: block;
                  }
                }

                .qrcode-area {
                  position: absolute;
                  background: #fff;
                  border: 1px solid #ccc;
                  border-radius: 4px;
                  z-index: 9;
                  display: none;
                  bottom: -205px;
                  left: 0;
                  transition: all 0.3s;
                  // transform: translateX(-50%);
                  overflow: hidden;

                  .qrcode {
                    width: 150px;
                    //height: 150px;
                  }
                }
              }

              .service-other {
                display: flex;
                align-items: center;

                .service-btn {
                  cursor: pointer;

                  a {
                    display: inline-block;
                    border: 1px solid @app-color;
                    color: @app-color;
                    padding: 4px 6px;
                    border-radius: 4px;
                  }
                }

                .service-tel {
                  display: flex;
                  gap: 4px;
                  flex-direction: column;
                  align-items: flex-start;
                  color: @app-color;
                  margin-right: 25px;
                  // text-align: justify;
                  font-family: 'Helvetica Neue', Arial, sans-serif;

                  .service-tel1 {
                    padding-left: 38px;
                    margin-bottom: 6px;
                    font-size: 14px;
                  }
                }
              }
            }
          }

          .fair-data {
            padding-bottom: 0;
            margin-bottom: 20px;
            // border-bottom: solid 1px #eaeaea;

            .content-line {
              margin-bottom: 8px;
              display: flex;

              .line_label {
                color: #666;
                font-weight: 500;
                margin-right: 8px;
                flex-shrink: 0;
                line-height: 24px;
              }

              .line_value {
                line-height: 1.5;
                letter-spacing: 1px;
              }

              .line_industry {
                margin-right: 0.5em;

                a {
                  display: inline-block;
                  color: #333;
                }
              }
            }
          }

          .data_box {
            margin-top: 16px;
            margin-bottom: 16px;
            padding: 0 18px 0 10px;
            display: flex;
            flex-wrap: wrap;
            font-size: 16px;
            color: #333;
            align-items: center;
            justify-content: space-between;

            > div {
              width: 50%;
              margin-bottom: 8px;
            }

            .data_label {
              margin-right: 8px;
            }

            i {
              width: 14px;
              margin-right: 5px;
            }
          }

          .introduction_exh {
            margin-bottom: 25px;

            p {
              font-size: 16px;
              color: #666;
              line-height: 1.8;
              margin-top: 13px;
              margin-bottom: 16px;
            }
          }

          .exh_range {
            display: block;
            // flex-flow: column;
            margin-top: 13px;
            // margin-bottom: 36px;
            p {
              margin: 10px 0 0 0;
            }
          }

          .pavilion {
            font-size: 16px;
            color: #666;
            line-height: 28px;
            // margin-bottom: 36px;
            margin-top: 14px;

            .pavilion_name {
              font-weight: bold;
              color: #333;

              .info-item_button {
                padding: 6px 10px;
                border-radius: 5px;
                font-size: 14px;
                font-family:
                  PingFangSC-Medium,
                  PingFang SC,
                  sans-serif;
                font-weight: 400;
                cursor: pointer;
                background: #e50113;
                color: #fff;
              }
            }

            .pavilion_address {
              margin-top: 10px;
            }

            .pavilion-area {
              display: flex;

              .img_con {
                width: 390px;
                height: 297px;
                display: flex;
                justify-content: center;
                align-items: center;
                border-radius: 6px;
                transform: translateZ(0);
                overflow: hidden;

                img {
                  // width: auto;
                  width: 390px;
                  min-width: 390px;
                  height: 297px;
                  object-fit: cover;
                  border-radius: 6px;
                  transform: translateZ(0);
                }
              }

              /deep/ .el-carousel {
                width: 390px;
                height: 295px;
                border-radius: 6px;
                transform: translateZ(0);
                overflow: hidden;

                .el-image__inner,
                .el-image__preview {
                  height: 295px;
                  object-fit: cover;
                }
              }

              /deep/ .pavilion_map {
                width: 390px !important;
                transform: translateZ(0);

                &:only-child {
                  width: 100%;
                }
              }
            }
          }

          .hotel-list {
            display: flex;
            flex-wrap: wrap;
            margin: 12px -4px 0;

            /deep/ .list-item {
              width: calc(50% - 8px);
              margin: 4px;
            }
          }

          /* 参展企业 */

          .join_exh_content {
            .shenqing_img {
              width: 200px;
              margin: 0 auto;
              display: flex;
              flex-flow: column;
              align-items: center;
              margin-bottom: 80px;

              p {
                font-size: 16px;
                color: #333;
                line-height: 19px;
              }
            }

            .exh_company_list {
              .company_item {
                display: flex;
                align-items: center;
                margin-top: 26px;

                .number {
                  font-size: 16px;
                  color: #666;
                  margin-right: 18px;
                }

                .img {
                  width: 167px;
                  height: 103px;
                  border-radius: 6px;
                  margin-right: 18px;
                  border: 1px solid #ddd;
                }

                .company_info {
                  .company_name {
                    width: 443px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    font-size: 18px;
                    color: #333;
                    line-height: 24px;
                    margin-bottom: 10px;
                  }

                  .company_desc {
                    width: 443px;
                    font-size: 16px;
                    color: #666;
                    line-height: 19px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                  }

                  .hot_reg {
                    margin-top: 30px;
                    font-size: 16px;
                    color: #333;
                    line-height: 19px;
                  }
                }

                .detail_btn {
                  width: 76px;
                  height: 30px;
                  border-radius: 4px;
                  border: 1px solid #d4d4d4;
                  font-size: 14px;
                  color: #666;
                  line-height: 30px;
                  text-align: center;
                  margin-left: 37px;
                }
              }
            }
          }

          .article-div {
            overflow: hidden;
            max-height: 180px;
            transition: max-height 0.3s;
          }

          .look_more {
            width: 113px;
            height: 37px;
            border-radius: 19px;
            border: 1px solid @app-color;
            display: flex;
            color: @app-color;
            justify-content: center;
            align-items: center;
            margin: 0 auto;
            margin-top: 14px;

            span {
              margin-right: 5px;
              font-size: 16px;
              color: @app-color;
            }

            &:hover {
              cursor: pointer;
            }
          }

          .procedure {
            display: flex;
            flex-wrap: wrap;

            p {
              width: 50%;
              font-size: 16px;
              color: #666;
              line-height: 29px;
            }
          }

          .download_btn {
            width: 138px;
            height: 42px;
            background: #e50113;
            border-radius: 6px;
            font-size: 16px;
            color: #fff;
            display: flex;
            align-items: center;
            justify-content: center;

            &:hover {
              cursor: pointer;
            }
          }
        }
      }

      .detail_right {
        flex: 1;

        .aside-sticky {
          //min-height: 100vh;
          // position: sticky;
          top: -260px;
          background: #f7f7f7;
          z-index: 1000;
        }

        .exposer-line {
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-bottom: 8px;

          .line-left {
            .num {
              color: #f00000;
            }
          }

          .line-right {
            flex-shrink: 0;
            display: flex;
            align-items: center;
            gap: 8px;

            .tag-item {
              display: inline-block;
              // width: 20px;
              height: 20px;
              line-height: 20px;
              text-align: center;
              border-radius: 4px;
              font-size: 14px;
              color: #fff;
              padding: 0 4px;
            }

            .tag-item__b {
              background: #6ac5be;
            }

            .tag-item__t {
              background: #ef2b2b;
            }
          }
        }

        .read_buy_content {
          background: #fff;
          padding: 12px 16px 12px 16px;
          border-radius: 6px;
          font-weight: 600;
          display: flex;
          flex-wrap: wrap;
          justify-content: space-between;
          margin-bottom: 12px;

          .btn {
            width: 142px;
            height: 42px;
            text-align: center;
            line-height: 42px;
            font-size: 16px;
            border-radius: 4px;

            &:hover {
              cursor: pointer;
            }
          }

          .buy {
            background: #363636;
            color: #fff;
            transition: all 0.3s;

            &:hover {
              letter-spacing: 1px;
            }
          }

          .apply-btn-box {
            width: 100%;
            display: flex;
            justify-content: space-between;

            .application_btn__only {
              margin-bottom: 0;

              &:only-child {
                width: 100%;

                .btn,
                .application_btn {
                  width: 100%;
                }
              }
            }
          }

          .application_btn {
            width: 142px;
            height: 42px;
            border-radius: 4px;
            border: 1px solid #363636;
            background: #363636;
            font-size: 16px;
            color: #fff;
            line-height: 38px;
            text-align: center;
            cursor: pointer;
            transition: all 0.3s;
            margin-bottom: 10px;

            &:hover {
              //background: #fce6e7;
              font-weight: 500;
              letter-spacing: 1px;
            }
          }
        }

        .read_buy_content2 {
          background: #fff;
          padding: 12px 16px 12px 16px;
          border-radius: 6px;
          font-weight: 600;
          display: flex;
          flex-wrap: wrap;
          justify-content: space-between;
          margin-bottom: 12px;

          .application_btn {
            width: 147px;
            height: 98px;
            opacity: 1;
            border-radius: 6px;
            background: linear-gradient(to right, #e50113, #fd7f42);
            font-weight: 500;
            letter-spacing: 0;
            line-height: 53px;
            color: #fff;
            cursor: pointer;
            display: flex;
            justify-items: center;
            justify-content: center;
            align-items: center;
            font-size: 20px;
            transition: background-image 0.5s ease;

            img {
              width: 35px;
            }

            &:hover {
              background: linear-gradient(90deg, #fd7f42, #e50113);
            }
          }

          .right {
            gap: 10px;
          }

          .btn {
            width: 135px;
            height: 44px;
            opacity: 1;
            border-radius: 6px;
            background: linear-gradient(to right, #e50113, #fd7f42);
            font-size: 16px;
            font-weight: 500;
            letter-spacing: 0;
            line-height: 44px;
            color: #fff;
            cursor: pointer;
            text-align: center;
            // padding-left: 15px;
            position: relative;
            overflow: hidden;

            .bg {
              // background: url('assets/images/button_back2.png') 100px 10px no-repeat;
            }

            &:hover {
              cursor: pointer;
              background: linear-gradient(90deg, #fd7f42, #e50113);
            }
          }

          .buy {
            background: #363636;
            color: #fff;
            transition: all 0.3s;
          }

          .apply-btn-box {
            width: 100%;
            display: flex;
            justify-content: space-between;

            .application_btn__only {
              margin-bottom: 0;
            }
          }
        }

        .read_tip {
          padding: 25px 20px 30px 17px;
          border-radius: 6px;
          background: #fff;
          margin-bottom: 12px;

          .tip_tit {
            display: flex;
            justify-content: space-between;
            padding-bottom: 17px;
            border-bottom: 1px solid #dadada;

            .tit_left {
              font-size: 16px;
              color: #333;
            }

            .tit_right {
              font-size: 16px;
              color: #333;
            }
          }

          .tip_content {
            display: flex;
            margin-top: 25px;

            img {
              margin-right: 25px;
            }

            p {
              font-size: 14px;
              color: #333;
              line-height: 24px;

              span {
                color: #d63627;
                font-size: 16px;
              }
            }
          }
        }

        .notice {
          margin: 12px 0;
          border-radius: 6px;
          background: #fff;
          // padding: 16px 19px 22px 17px;
        }

        .notice_content {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-top: 9px;

          .notice_left {
            .add_my {
              font-size: 14px;
              color: #333;
              line-height: 24px;
            }

            .get_my a {
              margin-top: 2px;
              font-size: 12px;
              color: #e82332;
              line-height: 24px;
            }
          }

          .notice_right {
            .but {
              padding: 10px;
              border-radius: 5px;
              font-size: 14px;
              font-family:
                PingFangSC-Medium,
                PingFang SC,
                sans-serif;
              font-weight: 400;
              cursor: pointer;
            }

            .onbut {
              background: #e50113;
              color: #fff;
            }

            .offbut {
              background: #ccc;
              color: #5f5f5f;
            }
          }
        }

        .notice_tit {
          font-size: 16px;
          color: #333;
          font-weight: 800;
          // padding-bottom: 6px;
          // border-bottom: 1px solid #dadada;
        }

        .server-area {
          margin: 12px 0;
          padding: 16px 19px 22px 17px;
          background: #fff;
          border-radius: 6px;
          // overflow: hidden;

          .server {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-top: 16px;
            margin-bottom: 10px;
            font-size: 16px;

            .server-left {
              display: flex;
              flex-direction: row;

              .server-icon {
                margin-right: 16px;
              }
            }

            .server-info {
              display: flex;
              flex-direction: column;
              justify-content: center;
              // align-items: center;

              .server-name {
                font-size: 16px;
              }

              .server-pai {
                color: #666;
              }
            }

            .server-btn {
              display: flex;
              align-items: baseline;
              cursor: pointer;

              a {
                color: @app-color;
              }
            }

            img {
              width: 48px;
              height: 48px;
              border-radius: 50%;
            }
          }

          .service-other {
            .service-tel {
              line-height: 24px;
              color: #e50113;
            }

            .service-qrcode {
              display: flex;
              align-items: center;
              margin: 0 40px 0 0;
              position: relative;
              font-size: 14px;

              span {
                padding-right: 0.5em;
              }

              .wechat-icon {
                cursor: pointer;
                width: 32px;

                &:hover + .qrcode-area {
                  display: block;
                }
              }

              .qrcode-area {
                position: absolute;
                background: #fff;
                border: 1px solid #ccc;
                border-radius: 4px;
                z-index: 9;
                display: none;
                bottom: -205px;
                left: 0;
                transition: all 0.3s;
                overflow: hidden;

                .qrcode {
                  width: 150px;
                }
              }
            }
          }
        }

        .tag-area {
          margin: 12px 0;
          padding: 16px 19px 22px 17px;
          background: #fff;
          border-radius: 6px;
          overflow: hidden;

          .notice_tit {
            padding-bottom: 13px;
          }

          .tag-list {
            a {
              margin-right: 6px;
              margin-bottom: 6px;
              display: inline-block;

              &:last-child {
                margin-right: 0;
              }
            }

            .tag-item {
              background: #f8f8f8;
              border-radius: 4px;
              padding: 2px 6px;
              font-size: 14px;
              border: 1px solid #eee;
              transition: 0.3s;
              white-space: nowrap;
              display: inline-block;

              &:hover {
                border-color: @app-color;
                color: @app-color;
              }
            }
          }
        }

        .tips-area {
          background: #fff;
          margin: 12px 0;
          box-sizing: border-box;
          padding: 16px 20px 20px;
          border-radius: 6px;

          .tips-title {
            margin-bottom: 10px;
            font-weight: 800;
          }

          .tips-content {
            color: #666;
            font-size: 14px;
            line-height: 20px;
          }
        }

        .evaluate {
          margin: 12px 0;
          display: flex;
          padding: 17px;
          align-items: center;
          border-radius: 6px;
          background: #fff;
          justify-content: space-between;

          .evaluate_left {
            font-size: 16px;
            color: #333;
            line-height: 21px;
          }

          .evaluate_right {
            font-size: 16px;
            line-height: 24px;

            a {
              color: #e82332;
            }

            &:hover {
              cursor: pointer;
            }
          }
        }

        .wechat-area {
          // padding: 17px;
          background: #fff;
          margin-top: 12px;
          border-radius: 4px;

          .wechat-list {
            display: flex;
            justify-content: space-between;
            margin-top: 16px;

            .wechat-item {
              // border: 1px solid #ccc;
              border-radius: 4px;
              overflow: hidden;
              display: flex;
              flex-direction: column;
              align-items: center;

              img {
                width: 140px;
              }

              .wechat-desc {
                font-size: 14px;
                margin: 8px 0;
              }
            }
          }
        }

        .comment_content {
          padding: 17px;
          background: #fff;
          margin-top: 12px;

          .comment {
            padding-bottom: 13px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            border-bottom: 1px solid #dadada;

            .comment_num {
              color: #e82332;
              font-size: 16px;
            }

            .evaluate_right {
              display: flex;
              align-items: center;

              .sub_num {
                font-size: 30px;
                font-weight: bold;
                color: #333;
                line-height: 34px;
                font-style: oblique;
              }

              .el-rate__icon {
                margin-right: 0 !important;
              }
            }
          }

          .comment_list {
            padding-left: 12px;

            .comment_item {
              display: flex;
              align-items: center;
              margin-top: 15px;

              .label {
                width: 85px;
                font-size: 14px;
                color: #555;
                margin-right: 15px;
                text-align: justify;
                text-justify: distribute-all-lines;
                text-align-last: justify;
                -moz-text-align-last: justify;
                -webkit-text-align-last: justify;
              }

              .progress {
                flex: 1;

                .el-progress-bar {
                  padding-right: 20px;
                  margin-bottom: 3px;
                }
              }
            }
          }
        }
      }
    }

    .order-message-box {
      background: #fff;
      padding: 15px 16px 15px 16px;
      border-radius: 6px;
      margin-bottom: 12px;
      cursor: pointer;

      .order-message {
        font-size: 14px;
        line-height: 26px;
        display: flex;

        img {
          width: 24px;
          height: 24px;
          border: 1px solid #f8f8f8;
          border-radius: 50%;
          transform: translateZ(0);
          margin-right: 4px;
        }
      }

      .avatar_div {
        display: flex;
        align-items: center;

        .avatar-list {
          margin-top: 10px;
          display: flex;

          .avatar_box {
            margin-left: -10px;

            .set-img {
              width: 30px;
              height: 30px;
              border-radius: 50%;
              object-fit: cover;
            }

            &:first-child {
              margin-left: 0;
            }
          }
        }

        .avatar_name {
          width: 140px;
          font-size: 14px;
          margin: 10px 0 0 20px;
          // flex: 1;
          text-align: center;
          overflow: hidden; /* 隐藏溢出内容 */
          text-overflow: ellipsis; /* 使用省略号表示溢出的文本 */
          white-space: nowrap; /* 防止文本换行 */
        }
      }

      &__t {
        background: transparent;
        width: 240px;
        height: 36px;
        overflow: hidden;
        position: relative;
        top: 0;
        right: 0;
        transform: translateY(-12px);
        padding: 0;

        .order-message {
          color: #fff;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
      }
    }

    .series_exh {
      width: 1190px;
      margin: 38px auto 14px auto;

      .exh_list {
        display: flex;
        flex-wrap: wrap;
        margin-top: 18px;
        width: 1190px;
        overflow: auto;

        .exh_item {
          width: 388px;
          margin-right: 12px;

          &:nth-child(3n) {
            margin-right: 0;
          }
        }
      }
    }

    .recommend_exh {
      width: 1190px;
      margin: 0 auto 10px;

      .title_more {
        display: flex;
        margin-top: 25px;
        margin-bottom: 18px;

        .more {
          margin-left: auto;
          font-size: 16px;
          font-weight: 400;
          color: #333;
          display: flex;
          align-items: center;

          svg {
            width: 16px;
          }
        }
      }

      .recommend_exh_list {
        display: flex;
        flex-wrap: wrap;

        .exh_item {
          margin-right: 12px;

          &:nth-child(4n) {
            margin-right: 0;
          }
        }
      }
    }

    .footer-new-card {
      display: flex;
      width: @client-width;
      margin: 0 auto;

      .news_bottom {
        width: 388px;
        margin-right: 12px;

        &:last-child {
          margin-right: 0;
        }
      }
    }

    .hot_country {
      width: 1190px;
      margin: 16px auto;
      padding: 20px 39px;
      background: #fff;
      border-radius: 6px;

      .tab_head {
        gap: 10px 20px;
        margin-bottom: 10px;

        .tab_name {
          padding-bottom: 3px;
          font-size: 15px;
          border-bottom: solid 2px #fff;

          &.active {
            border-bottom: solid 2px @app-color;
          }

          &:hover {
            cursor: pointer;
          }
        }
      }

      .tab_content {
        gap: 10px;
      }

      .country_list {
        a {
          font-size: 15px;
          color: #333;
          min-width: 129px;
          // margin-right: 20px;
          // margin-bottom: 10px;

          &:nth-child(8n) {
            margin-right: 0;
          }
        }
      }
    }
  }

  .pagination-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 12px;
  }

  .industry-news-box {
    background: #fff;
    border-radius: 4px;

    &__header {
      padding: 16px 16px 6px;
    }

    &__top {
      display: flex;
      flex-wrap: wrap;
    }

    .news-list {
      display: flex;
      flex-wrap: wrap;
      gap: 10px;
      padding: 10px 16px;
      border-top: 1px solid #eee;

      .news-item {
        display: inline-block;
        width: calc(33% - 3px);
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;

        &::before {
          content: '·';
          margin-right: 4px;
          font-size: 18px;
          font-weight: bold;
        }
      }
    }
  }

  @media screen and (max-width: 1280px) {
    .title_content {
      display: none;
    }
  }

  .Exhibition-info {
    display: flex;
    justify-content: space-between;
    width: 100%;
    margin: 20px 0 12px 0;

    .Exhibition-li {
      width: 120px;
      display: flex;

      img {
        width: 40px;
        height: 40px;
      }

      .Exhibition-text {
        margin-left: 10px;

        .cycle-text {
          font-size: 12px;
          line-height: 16px;
          color: rgba(255, 255, 255, 0.78);
          margin-bottom: 3px;
        }

        .cycle-content {
          font-size: 14px;
          font-weight: 400;
          color: #fff;
          line-height: 19px;
        }
      }
    }
  }

  .periodical-price {
    min-width: 200px;
    margin-right: 30px;

    span {
      font-weight: bold;
      font-size: 20px;
      color: #ff5858;
      line-height: 28px;
    }
  }

  .ticket-price {
    .price_value {
      font-weight: bold;
      font-size: 20px;
      color: #ff5858;
      line-height: 24px;
      margin-left: 5px;
    }

    .oldPrice_value {
      text-decoration: line-through;
    }
  }

  .follow_dialog {
    height: 410px;
    margin-top: 0 !important;
    top: calc(50% - 225px);
    border-radius: 12px !important;
    position: relative;

    .el-dialog__header {
      display: none;
      padding: 0.5px;
    }

    .el-dialog__body {
      height: 100%;
      padding: 0.5px;
    }
  }

  .focus_qrcode_box {
    position: absolute;
    top: 0;
    left: 0;
    width: 700px;
    border-radius: 6px;
    background: #fff;

    .close_icon2 {
      width: 24px;
      height: 24px;
      position: absolute;
      top: 20px;
      right: 20px;
      cursor: pointer;
    }

    .focus_qrcode_header {
      margin-top: 40px;

      .success_text {
        font-weight: bold;
        font-size: 18px;
        color: #333;
        text-align: center;
      }

      .guidance {
        font-size: 14px;
        color: #999;
        margin-top: 12px;
        display: flex;
        justify-content: center;

        span {
          cursor: pointer;
        }
      }
    }

    .qrcode_All {
      width: 100%;
      display: flex;
      justify-content: center;
      margin-bottom: 40px;

      .qrcode_left {
        .scanCodeText {
          margin: 23px 0 0 20px;
          font-size: 18px;
          color: #333;
        }

        .qrcode_box {
          width: 100%;
          margin-top: 15px;
          text-align: center;

          img {
            width: 200px;
            height: 200px;
          }
        }

        .scanCodeTip {
          text-align: center;
          font-size: 14px;
          color: #333;
          font-weight: bold;
          margin-bottom: 8px;
        }

        .fousInfo {
          text-align: center;
          font-size: 14px;
          color: #999;
          margin-top: 3px;
        }

        &.qrcode_right {
          margin-left: 120px;
        }
      }
    }
  }

  .footer-float {
    width: 100%;
    height: 80px;
    background: #fff;
    position: fixed;
    bottom: 0;
    z-index: 99;
    box-shadow: 0 -4px 20px 1px rgba(0, 0, 0, 0.1);

    .float_box {
      width: 1190px;
      height: 100%;
      margin: 0 auto;
      // display:flex;
      // align-items: center;
      position: relative;

      .float_content_box {
        margin: 0 auto;
        display: flex;
        align-items: center;
        transform: translateX(-50%);
        position: absolute;
        left: 50%;

        img {
          width: 127px;
          height: 80px;
          object-fit: contain;
        }
      }

      .float-exhibition-box {
        display: flex;

        .float-exhibition-info {
          font-size: 14px;
          color: #999;
          line-height: 19px;
          max-width: 670px;
          margin-left: 15px;

          .info_name {
            font-weight: bold;
            font-size: 20px;
            color: #000;
            line-height: 28px;
            width: 100%;
            margin-top: 5px;
          }

          .info_price {
            font-size: 12px;
            // margin-bottom:
            .price_value {
              font-weight: bold;
              font-size: 20px;
              color: #e00022;
              line-height: 24px;
            }

            .original_price {
              text-decoration: line-through;
            }
          }

          .info_time {
            font-size: 12px;
          }
        }

        .control-btn {
          display: flex;
          align-items: center;
          margin-left: 60px;

          .btn_text {
            width: 146px;
            height: 37px;
            background: #e00022;
            border-radius: 4px;
            text-align: center;
            line-height: 37px;
            color: #fff;
            font-weight: 400;
            font-size: 18px;
            margin-right: 20px;
            cursor: pointer;
          }
        }
      }
    }
  }
</style>
